


var isBlackFriday = false;
var intervalID;
var optionsInProgress = false;
var currentSku = null;
var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var guardianAPI = {
  updatePrice: function (price, customMessage) {
    var formattedPrice = guardianAPI.formatPrice(price)
    $('.affirm-as-low-as').attr('data-amount', price);
    if (affirm && affirm.ui && affirm.ui.refresh) {
      affirm.ui.refresh();
    }
    if (customMessage) {
//       $('#AddToCart').text(customMessage+" - "+formattedPrice);
//       $('.header_add_to_cart_btn, .header_add_to_cart_btn_new').text(customMessage+" - "+formattedPrice);
//       $('.in_page_add_to_cart_btn').text(customMessage);
      $('.product-price').html(formattedPrice);
    } else {
//       $('#AddToCart').text("Add to Cart");
//       $('.header_add_to_cart_btn, .header_add_to_cart_btn_new').text("Add to Cart - "+formattedPrice);
//       $('.in_page_add_to_cart_btn').text("Add to Cart");
      $('.product-price').html(formattedPrice);
    }
  },
  addToCart:function(variantId) {
    var urlParams = new URLSearchParams(window.location.search);
    var variantQueryString = urlParams.get('variant');
    var currentVariantId = variantQueryString ? variantQueryString : variantId
    var abc = "?quantity=1&id=13604286300253"
    //ShopifyAPI.addItemFromForm(abc)
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: {
//       	quantity: 1,
//         id: currentVariantId,
//         properties: {
//           'test': '123'
//         }
//       },
//       dataType: 'json',
//       complete: function(response) {
//         if (response.status !== 200) {
//           console.log(response.responseText);
//           console.log("Error adding item");
//         } else {
//           console.log("completed");
//           var cart = cartResponse.responseJSON
//           guardianAPI.updateCartInfo(cart)
//         }
//       },
//     })
             
  },
  updateCartInfo: function (cart) {
    //console.log("cart", cart);
  },
  setOutOfStock: function (variant, isBike) {
    var formattedPrice = guardianAPI.formatPrice(variant.price)
    if (!isBike) {
//       $('#AddToCart').text("Add to Cart");
//       $('.header_add_to_cart_btn, .header_add_to_cart_btn_new').text("Add to Cart - "+formattedPrice);
      $(".header_add_to_cart_btn, .in_page_add_to_cart_btn").addClass("cta_sold_out_btn");
      $(".header_add_to_cart_btn, .in_page_add_to_cart_btn").attr('disabled', true)
    } else {
//       $('#AddToCart').text("Add to Cart");
//       $('.header_add_to_cart_btn, .header_add_to_cart_btn_new').text("Add to Cart - "+formattedPrice);
      $(".header_add_to_cart_btn, .in_page_add_to_cart_btn").removeClass("cta_sold_out_btn");
      $(".header_add_to_cart_btn, .in_page_add_to_cart_btn").attr('disabled', false)
    }

  },
  setInStock: function () {
    $('div[data-id="icon-out-of-stock"]').hide();
    $('div[data-id="icon-in-stock"]').show();
    $('div[data-id="icon-in-stock"] .product-icon-and-text--text big').text('In Stock')
    $('div[data-id="icon-in-stock"] .product-icon-and-text--subtext').text('Ships within 2 business days')
    $('div[data-id="icon-in-stock"] .product-icon-and-text--subtext2').text('')
    $('div[data-id="icon-in-stock"] .product-icon-and-text--subtext3').text('')
    $(".header_add_to_cart_btn, .in_page_add_to_cart_btn").removeClass("cta_sold_out_btn");
    $(".header_add_to_cart_btn, .in_page_add_to_cart_btn").attr('disabled', false)
  },
  hideDeliveryInfo: function () {
    clearInterval(intervalID)
    var deliveryInfo = document.querySelector('.delivery-info');
    if (!deliveryInfo) {
      return;
    }
    deliveryInfo.style.display = 'none';
    $(".delivery-time-estimate").show()
    $(".delivery-time-real").hide()
    document.querySelector('.zip-form-container').classList.remove('zip-form-container-show')
  },
  getCurrentDeliveryInfo: function (dayOfWeek) {
    var d = new Date();
    var c = new Date(+d);
    var currentUTCHours = c.getUTCHours()
    var currentUTCDate = c.getUTCDate()
    var totalSecondsTilEnd
    if (currentUTCHours >= 19) {
      //  If day of week is 7 (saturday) then add 2 days, otherwise 1
      var daysToAdd = dayOfWeek == 7 ? 2 : 1;
      var nextUTCDate = new Date(c.setUTCDate(currentUTCDate+daysToAdd,21,0,0,0))
      totalSecondsTilEnd = (nextUTCDate.setUTCHours(21,0,0,0) - d) / 1000;
    } else {
      totalSecondsTilEnd = (c.setUTCHours(21,0,0,0) - d) / 1000;
    }
    var hoursTilEnd = parseInt(totalSecondsTilEnd/(60*60))
    var minutesTilEnd = parseInt((totalSecondsTilEnd-(hoursTilEnd*60*60))/60)
    var secondsTilEnd = parseInt(totalSecondsTilEnd - (hoursTilEnd*60*60) - (minutesTilEnd*60))
    return {hoursTilEnd:hoursTilEnd, minutesTilEnd:minutesTilEnd, secondsTilEnd:secondsTilEnd}
  },
  showDeliveryInfo: function (product, variant) {
// 	guardianAPI.getTransitTime();
  },
  showZipAvailability: function () {
    $('.confirm-delivery-button, .confirm-delivery-button-mobile').show();
    $('.zip-form-container, .zip-form-container-mobile').show();
    $('.delivery-time, .delivery-time-mobile').show();
  },
  hideZipAvailability: function () {
    $('.zip-delivery-message').hide()
    $('.confirm-delivery-button, .confirm-delivery-button-mobile').hide();
    $('.zip-form-container, .zip-form-container-mobile').hide();
    //$('.delivery-time, .delivery-time-mobile').hide();
  },
  removeProperty: function (key) {
    let keySlug = key.replaceAll(' ', '_')
    $("#preorded-property-"+keySlug).remove()
  },
  addProperty: function (key, value) {
    let keySlug = key.replaceAll(' ', '_')
    var input = $('<input id="preorded-property-'+keySlug+'" type="hidden" name="properties['+key+']" value="'+value+'" />')[0]
    $("#AddToCartForm").append(input)
  },
  setPrice: function (price) {
    if (price%100 == 0) {
      $('.price_block').text("$"+(price/100))
    } else {
      $('.price_block').text("$"+(price/100).toFixed(2))
    }
  },
  handleChangeImages: function (product, sku, firstLoad) {
      if (product.type != 'Kids Bikes' && product.type != 'Helmets' && product.type != 'Bells' && product.type != 'Accessories') {
        return;
      }
      
      $('.swatch_thumb').hide();
      $(".swatch_thumb").css("opacity", "0");
      $('.swatch_thumb').removeClass("active");

      var variantSkuDashed = sku.split(' / ').join(' ').split(' ').join('-').replaceAll(':', '-').toLowerCase();
      $(".swatch_thumb."+variantSkuDashed).css("display", "inline-block");
      $(".swatch_thumb."+variantSkuDashed).css("opacity", "1");
      $(".swatch_thumb."+variantSkuDashed).addClass("active");
    var swatchThumbs = $(".swatch_thumb")
    swatchThumbs.each(function(k, swatchThumb) {
      var swatchAlt = swatchThumb.dataset.alt
      var hasSku = Array.from(swatchThumb.classList).some(function(each) {
        if (product.type == 'Kids Bikes' || product.type == 'Helmets') {
          return each.indexOf(variantSkuDashed) > -1
        } else {
          return each === variantSkuDashed
        }
      })
      if ((swatchAlt && swatchAlt.toLowerCase().indexOf('all')  > -1) || hasSku) {
        swatchThumb.style.display = "inline-block"
        swatchThumb.style.opacity = 1
        swatchThumb.classList.add("active")
      }
    })
      $($("."+variantSkuDashed+".active")[0]).addClass("selected");
      
      
//       $(".owl-carousel").trigger('refresh.owl.carousel');
      setTimeout(function  () {
      	$(".owl-carousel").trigger('refresh.owl.carousel');
      }, 2000) 
      
      
//     }, 200)

  },
  setPDPInfo: function (product, variant, firstLoad) {
    if (!variant.sku) {
        return;
    }

    var variantSKU = variant.sku.replaceAll(':', "-");

    // SKU level: Show/Hide blocks based on variant SKU
    $('.variant-level-info').addClass('variant-level-info--hide');
    $('.variant-level-info[data-variant="' + variant.sku + '"]').removeClass('variant-level-info--hide');

    // Option1 level: Show/Hide blocks based on option1 value
    if (variant.options && variant.options.length > 0) {
        $('.option1-level-info').addClass('variant-level-info--hide');
        $('.option1-level-info[data-option1="' + variant.options[0] + '"]').removeClass('variant-level-info--hide');
    }

    // Option2 level (if needed)
    if (variant.options && variant.options.length > 1) {
        $('.option2-level-info').addClass('variant-level-info--hide');
        $('.option2-level-info[data-option2="' + variant.options[1] + '"]').removeClass('variant-level-info--hide');
    }

    // Option3 level (if needed)
    if (variant.options && variant.options.length > 2) {
        $('.option3-level-info').addClass('variant-level-info--hide');
        $('.option3-level-info[data-option3="' + variant.options[2] + '"]').removeClass('variant-level-info--hide');
    }

    $('.variant-description-text').hide();
    $('.variant-description-text[data-sku=' + variantSKU + ']').show();
    $('.variant-features-text').hide();
    $('.variant-features-text[data-sku=' + variantSKU + ']').show();

    var colorIndex = product.options.findIndex(function(each) {
        return each === 'Color';
    });
    if (colorIndex > -1) {
        $('.variant_color').text(variant["option" + (colorIndex + 1)]);
    }

    // Model-specific adjustments
    if (product.title.toLowerCase().indexOf('14 inch') > -1) {
        $('.pro_text_image_col[data-model=airos]').removeClass("pro_text_image_col_active");
        $('.pro_text_image_col[data-model=ethos]').addClass("pro_text_image_col_active");
        $('.pro_text_image_cols[data-model=airos]').removeClass("pro_text_image_cols_active");
        $('.pro_text_image_cols[data-model=ethos]').addClass("pro_text_image_cols_active");
    } else if (variant.title.toLowerCase().indexOf('ethos') > -1) {
        $('.pro_text_image_col[data-model=airos]').removeClass("pro_text_image_col_active");
        $('.pro_text_image_col[data-model=ethos]').addClass("pro_text_image_col_active");
        $('.pro_text_image_cols[data-model=airos]').removeClass("pro_text_image_cols_active");
        $('.pro_text_image_cols[data-model=ethos]').addClass("pro_text_image_cols_active");
    } else if (variant.title.toLowerCase().indexOf('airos') > -1) {
        $('.pro_text_image_col[data-model=airos]').addClass("pro_text_image_col_active");
        $('.pro_text_image_col[data-model=ethos]').removeClass("pro_text_image_col_active");
        $('.pro_text_image_cols[data-model=airos]').addClass("pro_text_image_cols_active");
        $('.pro_text_image_cols[data-model=ethos]').removeClass("pro_text_image_cols_active");
    }

    if (!firstLoad) {
        $(".image-gallery-slider").css("opacity", 0);
        $('.image-gallery-slider').removeClass('image-gallery-slider--active');
    }
    $(".image-gallery-slider").css("opacity", 1);
    $('.image-gallery-slider').hide();
    $('.image-gallery-slider[data-sku=' + variantSKU + ']').show();
    $('.image-gallery-slider[data-sku=' + variantSKU + ']').addClass('image-gallery-slider--active');
    $('.image-gallery-slider[data-sku=' + variantSKU + '] .owl-carousel').trigger('refresh.owl.carousel');
    $('.image-gallery-slider[data-sku=' + variantSKU + '] .owl-carousel').trigger("to.owl.carousel", [0, 0]);

    

    $('.optional-accessory-input').removeAttr('checked');
    $('.recommended-bundles-container .gb-slider-checkbox').removeAttr('checked');
    $('.recommended-bundles-container .gb-slider-checkbox').prop('checked', false);

    var recommendedBundles = $('.recommended-bundles');
    $('.recommended-bundle').removeClass('recommended-bundle--selected');
    recommendedBundles.each((k, v) => {
        $(v).removeClass('recommended-bundles--active');
    });
    $('.recommended-bundles[data-sku="' + variantSKU + '"]').addClass('recommended-bundles--active');
    $('.recommended-bundles[data-sku="' + variantSKU + '"] .recommended-bundle').addClass('recommended-bundle--active');

    

    var recommendedHelmets = $('.optional-accessory-container--helmet-bundle .optional-accessory-label--helmet');
    recommendedHelmets.removeClass('optional-accessory-label--helmet--selected');
    recommendedHelmets.removeClass('optional-accessory-label--helmet--active');
    $('.optional-accessory-container--helmet-bundle .optional-accessory-label--helmet[data-sku="' + variantSKU + '"]').addClass('optional-accessory-label--helmet--active');

    
    $('.training-wheels-installation-pdp-variant').addClass('training-wheels-installation-pdp-variant--hide')
    $('.training-wheels-installation-pdp-variant[data-sku="' + variantSKU + '"]').removeClass('training-wheels-installation-pdp-variant--hide')
    
    
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    }
	var currentModel = variant.option2 && variant.option2.toLowerCase()
    var otherModel = currentModel && currentModel == "ethos" ? "airos" : "ethos" 
    var otherVariant = currentModel && product.variants.find(each => each.option2.toLowerCase() == otherModel && each.option2 == variant.option2)

    var blackFridayDiscounts = {
      // "GBBB-12-BNG": 15,
      // "GBBB-12-GEL": 15,
      // "GBBB-12-MP": 15,
      // "GBE-16-1-BB": 15,
      // "GBE-16-1-PT": 15,
      // "GBE-16-1-GEL": 15,
      // "GBE-16-1-MP": 15,
      // "GBE-20-1-BNG": 15,
      // "GBE-20-6-BG": 15,
      // "GBE-20-6-PA": 15,
      // "GBE-20-6-GEL": 15,
      // "GBE-24-7-BG": 15,
      // "GBE-24-7-BR": 15,
      // "GBE-24-7-LB": 15,
      // "GBE-24-7-GEL": 15,
      // "ONLINE-GB1-20-S-1-BR": 15,
      // "ONLINE-GB1-20-S-1-AP": 15,
      // "ONLINE-GB1-20-S-1-BNG": 15,
      // "ONLINE-GB1-26-7-GEL": 15,
      // "ONLINE-GB1-26-7-BG": 15,
      // "ONLINE-GB1-26-7-BP": 15,
      // "ONLINE-GB1-20-6-PA": 25,
      // "ONLINE-GB1-20-6-GEL": 25,
      // "GBE-20-1-AP": 25,
      // "GBE-20-1-BR": 25,
      // "ONLINE-GB1-20-6-BG": 15,
      // "ONLINE-GB1-24-7-BG": 15,
      // "ONLINE-GB1-24-7-LB": 15,
      // "ONLINE-GB1-24-7-GEL": 15,
      // "ONLINE-GB1-24-7-BR": 25,
        // ,"7095276": 15  
        // ,"7095282": 15  
        // ,"7089376": 15  
        // ,"7095279": 15  
        // ,"7089373": 15  
        // ,"7087493": 15 
        // ,"7087494": 15 
        // ,"7141889": 15 
        // ,"7141122": 15 
        // ,"7141123": 15 
    };
    var asLowAsContainer = document.querySelector(".as-low-as-savings-price")
    if (product.type == "Gift Card") {
      return;
    } else if (isBlackFriday) {
      if (blackFridayDiscounts[variant.sku] && asLowAsContainer) {
          asLowAsContainer.style.opacity = 1;
          asLowAsContainer.querySelector("p").innerHTML = "You Save "+blackFridayDiscounts[variant.sku]+"%"
      } else if (asLowAsContainer) {
          asLowAsContainer.style.opacity = 0;
          asLowAsContainer.querySelector("p").innerHTML = ""
      }
    }

    if (product.type != 'Kids Bikes') {
      return;
    }
    if (isBlackFriday && product.type != 'Kids Bikes') {
      var blackFridayDiscount = blackFridayDiscounts[variant.sku] ? blackFridayDiscounts[variant.sku] : 15
      var accessoryPrice = guardianAPI.formatPrice(variant.price*((100-blackFridayDiscount)/100))
      var accessoryComparePrice = guardianAPI.formatPrice(variant.price)
      document.querySelector('.product-price-and-shipping .product-price').innerHTML = accessoryPrice
      document.querySelector('.product-price-and-shipping .product-price-compare').innerHTML = accessoryComparePrice
      var itemPropPrice = document.querySelector('[itemprop="price"]')
      if (itemPropPrice) {
        itemPropPrice.setAttribute('content', accessoryPrice.replace('$', ''))
        itemPropPrice.innerHTML = accessoryPrice
      }
      var discountedPrice = document.querySelector(".as-low-as-discounted-price")
      var asLowAsTotalPrice = document.querySelector(".as-low-as-total-price")
      if (discountedPrice) {
        discountedPrice.innerHTML = accessoryPrice
      }
      if (asLowAsTotalPrice) {
        asLowAsTotalPrice.innerHTML = accessoryComparePrice
      }
      return;
    }
    
    $('.swatch-price-current').addClass('swatch-price-current--visible')
    
    var ethosPrice
    var ethosComparePrice
    var ethosPriceDiff
    var airosPrice
    var airosComparePrice
    var airosPriceDiff
    if (!otherVariant) {
      if (currentModel == "ethos") {
        ethosPrice = guardianAPI.formatPrice(variant.price);
        ethosComparePrice = variant.compare_at_price && guardianAPI.formatPrice(variant.compare_at_price);
        if (isBlackFriday && blackFridayDiscounts[variant.sku]) {
          ethosPrice = guardianAPI.formatPrice(variant.price*((100-blackFridayDiscounts[variant.sku])/100))
          ethosComparePrice = guardianAPI.formatPrice(variant.price)
          // airosPrice = guardianAPI.formatPrice((variant.price+10000)*((100-blackFridayDiscounts[variant.sku])/100))
          // airoaComparePrice = guardianAPI.formatPrice(variant.price+10000)
          // $('.swatch-element[data-value="AIROS"] .swatch-price-current').text(airosPrice);
          $('.swatch-element[data-value="AIROS"] .swatch-price-compare-at').text('');
        }
        if (ethosComparePrice) {
          var priceDiff = guardianAPI.formatPrice(variant.compare_at_price-variant.price);
          var pricePercent = Math.round(((variant.compare_at_price-variant.price)/variant.compare_at_price)*100)
          //         $('.swatch-element[data-value="ETHOS"] .model-tag').text('Save '+pricePercent+"%");
          $('.swatch-element[data-value="ETHOS"] .model-tag').text('Save '+priceDiff);
        } else {
          $('.swatch-element[data-value="ETHOS"] .model-tag').text('Most Popular');
        }
//         ethosPriceDiff = guardianAPI.formatPrice(otherVariant.compare_at_price);
        // $('.swatch-element[data-value="ETHOS"] .swatch-price-current').text(ethosPrice);
        // $('.swatch-element[data-value="ETHOS"] .swatch-price-compare-at').text(ethosComparePrice);
        console.log("@@@ ethosPrice", ethosPrice)
        console.log("@@@ ethosComparePrice", ethosComparePrice)
        if (ethosPrice === ethosComparePrice) {
          document.querySelector(".as-low-as-total-price").innerHTML = ""
          document.querySelector(".as-low-as-discounted-price").innerHTML = ethosPrice
        } else {
          document.querySelector(".as-low-as-total-price").innerHTML = ethosComparePrice
          document.querySelector(".as-low-as-discounted-price").innerHTML = ethosPrice
        }
        document.querySelector('[itemprop="price"]').setAttribute('content', ethosPrice.replace('$', ''))
        document.querySelector('[itemprop="price"]').innerHTML = ethosPrice

      } else if (currentModel == "airos") {
        airosPrice = guardianAPI.formatPrice(variant.price);
        airosComparePrice = variant.compare_at_price && guardianAPI.formatPrice(variant.compare_at_price);
        if (isBlackFriday && blackFridayDiscounts[variant.sku]) {
          // ethosPrice = guardianAPI.formatPrice((variant.price-10000)*((100-blackFridayDiscounts[variant.sku])/100))
          // ethosComparePrice = guardianAPI.formatPrice(variant.price-10000)
          airosPrice = guardianAPI.formatPrice(variant.price*((100-blackFridayDiscounts[variant.sku])/100))
          airosComparePrice = guardianAPI.formatPrice(variant.price)
          // $('.swatch-element[data-value="ETHOS"] .swatch-price-current').text(ethosPrice);
          $('.swatch-element[data-value="ETHOS"] .swatch-price-compare-at').text('');
        }
        // $('.swatch-element[data-value="AIROS"] .swatch-price-current').text(airosPrice);
        // $('.swatch-element[data-value="AIROS"] .swatch-price-compare-at').text(airosComparePrice);
        
        if (airosPrice === airosComparePrice) {
          document.querySelector(".as-low-as-total-price").innerHTML = ""
          document.querySelector(".as-low-as-discounted-price").innerHTML = airosPrice
        } else {
          document.querySelector(".as-low-as-total-price").innerHTML = airosComparePrice
          document.querySelector(".as-low-as-discounted-price").innerHTML = airosPrice
        }
        document.querySelector('[itemprop="price"]').setAttribute('content', airosPrice.replace('$', ''))
        document.querySelector('[itemprop="price"]').innerHTML = airosPrice
      } else if (isBlackFriday && blackFridayDiscounts[variant.sku]) {
        var blackFridayDiscount = blackFridayDiscounts[variant.sku]
        // var blackFridayDiscount = blackFridayDiscounts[variant.sku] ? blackFridayDiscounts[variant.sku] : 15
        if (isBlackFriday) {
          var balancePrice = guardianAPI.formatPrice(variant.price*((100-blackFridayDiscount)/100))
          var balanceComparePrice = guardianAPI.formatPrice(variant.price)
          $('.product-price-and-shipping .product-price').text(balancePrice)
          $('.product-price-and-shipping .product-price-compare').text(balanceComparePrice)
          document.querySelector('[itemprop="price"]').setAttribute('content', balancePrice.replace('$', ''))
          document.querySelector('[itemprop="price"]').innerHTML = balancePrice
        }
      }
      return;
    }
    

    var discount = document.getElementById("atc-property-fs")
    var discountValue = discount && discount.getAttribute('value')
    console.log("discountValue", discountValue)
    if (currentModel == "ethos") {
      if (discountValue) {
        ethosPrice = guardianAPI.formatPrice(variant.price-(discountValue*100));
        ethosComparePrice = variant.price && guardianAPI.formatPrice(variant.price);
        airosPrice = otherVariant && guardianAPI.formatPrice(otherVariant.price-(discountValue*100));
        airosComparePrice = otherVariant.price && guardianAPI.formatPrice(otherVariant.price);
        $('.affirm-as-low-as').attr('data-amount', variant.price-(discountValue*100));
      } else {
        ethosPrice = guardianAPI.formatPrice(variant.price);
        ethosComparePrice = variant.compare_at_price && guardianAPI.formatPrice(variant.compare_at_price);
        airosPrice = otherVariant && guardianAPI.formatPrice(otherVariant.price);
        airosComparePrice = otherVariant.compare_at_price && guardianAPI.formatPrice(otherVariant.compare_at_price);
        if (isBlackFriday && blackFridayDiscounts[variant.sku]) {
          ethosPrice = guardianAPI.formatPrice(variant.price*((100-blackFridayDiscounts[variant.sku])/100))
          ethosComparePrice = guardianAPI.formatPrice(variant.price);
          airosPrice = guardianAPI.formatPrice(otherVariant.price*((100-blackFridayDiscounts[otherVariant.sku])/100))
          airosComparePrice = guardianAPI.formatPrice(otherVariant.price);
          
          if (ethosPrice === ethosComparePrice) {
            document.querySelector(".as-low-as-total-price").innerHTML = ""
            document.querySelector(".as-low-as-discounted-price").innerHTML = ethosPrice
          } else {
            document.querySelector(".as-low-as-total-price").innerHTML = ethosComparePrice
            document.querySelector(".as-low-as-discounted-price").innerHTML = ethosPrice
          }
        }
        $('.affirm-as-low-as').attr('data-amount', variant.price);
      }
      if (ethosComparePrice) {
        var priceDiff = guardianAPI.formatPrice(variant.compare_at_price-variant.price);
        var pricePercent = Math.round(((variant.compare_at_price-variant.price)/variant.compare_at_price)*100)
//         $('.swatch-element[data-value="ETHOS"] .model-tag').text('Save '+pricePercent+"%");
        $('.swatch-element[data-value="ETHOS"] .model-tag').text('Save '+priceDiff);
      } else {
        $('.swatch-element[data-value="ETHOS"] .model-tag').text('Most Popular');
      }
      if (airosComparePrice) {
        var priceDiff = guardianAPI.formatPrice(otherVariant.compare_at_price-otherVariant.price);
        var pricePercent = Math.round(((otherVariant.compare_at_price-otherVariant.price)/otherVariant.compare_at_price)*100)
//         $('.swatch-element[data-value="AIROS"] .model-tag').text('Save '+pricePercent+"%");
        $('.swatch-element[data-value="AIROS"] .model-tag').text('Save '+priceDiff);
      } else {
        $('.swatch-element[data-value="AIROS"] .model-tag').text('2 lbs Lighter');
      }
      ethosPriceDiff = guardianAPI.formatPrice(otherVariant.compare_at_price);
	
    } else if (currentModel == "airos") {
      if (discountValue) {
        ethosPrice = otherVariant && guardianAPI.formatPrice(otherVariant.price-(discountValue*100));
        ethosComparePrice = otherVariant.price && guardianAPI.formatPrice(otherVariant.price);
        airosPrice = guardianAPI.formatPrice(variant.price-(discountValue*100));
        airosComparePrice = variant.price && guardianAPI.formatPrice(variant.price);
        $('.affirm-as-low-as').attr('data-amount', variant.price-(discountValue*100));
      } else {
        ethosPrice = otherVariant && guardianAPI.formatPrice(otherVariant.price);
        ethosComparePrice = otherVariant.compare_at_price && guardianAPI.formatPrice(otherVariant.compare_at_price);
        airosPrice = guardianAPI.formatPrice(variant.price);
        airosComparePrice = variant.compare_at_price && guardianAPI.formatPrice(variant.compare_at_price);
        if (isBlackFriday && blackFridayDiscounts[variant.sku]) {
          ethosPrice = guardianAPI.formatPrice(otherVariant.price*((100-blackFridayDiscounts[otherVariant.sku])/100))
          ethosComparePrice = guardianAPI.formatPrice(otherVariant.price);
          airosPrice = guardianAPI.formatPrice(variant.price*((100-blackFridayDiscounts[variant.sku])/100))
          airosComparePrice = guardianAPI.formatPrice(variant.price);
          if (airosPrice === airosComparePrice) {
            document.querySelector(".as-low-as-total-price").innerHTML = ""
            document.querySelector(".as-low-as-discounted-price").innerHTML = airosPrice
          } else {
            document.querySelector(".as-low-as-total-price").innerHTML = airosComparePrice
            document.querySelector(".as-low-as-discounted-price").innerHTML = airosPrice
          }
        }
        $('.affirm-as-low-as').attr('data-amount', variant.price);
      }
      
      if (ethosComparePrice) {
        var priceDiff = guardianAPI.formatPrice(otherVariant.compare_at_price-otherVariant.price);
        var pricePercent = Math.round(((otherVariant.compare_at_price-otherVariant.price)/otherVariant.compare_at_price)*100)
//         $('.swatch-element[data-value="ETHOS"] .model-tag').text('Save '+pricePercent+"%");
        $('.swatch-element[data-value="ETHOS"] .model-tag').text('Save '+priceDiff);
      } else {
        $('.swatch-element[data-value="ETHOS"] .model-tag').text('Most Popular');
      }
      if (airosComparePrice) {
        var priceDiff = guardianAPI.formatPrice(variant.compare_at_price-variant.price);
        var pricePercent = Math.round(((variant.compare_at_price-variant.price)/variant.compare_at_price)*100)
//         $('.swatch-element[data-value="AIROS"] .model-tag').text('Save '+pricePercent+"%");
        $('.swatch-element[data-value="AIROS"] .model-tag').text('Save '+priceDiff);
      } else {
        $('.swatch-element[data-value="AIROS"] .model-tag').text('2 lbs Lighter');
      }
    }
    if (affirm && affirm.ui && affirm.ui.refresh) {
      affirm.ui.refresh();
    }
    $('.swatch-element[data-value="ETHOS"] .swatch-price-current').text(ethosPrice);
    $('.swatch-element[data-value="ETHOS"] .swatch-price-compare-at').text(ethosComparePrice);
    $('.swatch-element[data-value="AIROS"] .swatch-price-current').text(airosPrice);
    $('.swatch-element[data-value="AIROS"] .swatch-price-compare-at').text(airosComparePrice);
    if  (currentModel == 'ethos') {
      document.querySelector('[itemprop="price"]').setAttribute('content', ethosPrice.replace('$', ''))
      document.querySelector('[itemprop="price"]').innerHTML = ethosPrice
    } else {
      document.querySelector('[itemprop="price"]').setAttribute('content', airosPrice.replace('$', ''))
      document.querySelector('[itemprop="price"]').innerHTML = airosPrice
    }

    

  },
  handleFetchInvetory: function (product, variant, isBike, firstLoad) {
    var nowTime = new Date().getTime()
    if (firstLoad == undefined) {
      firstLoad = false;
    }
    if (product.title.toLowerCase().indexOf("helmet") > -1 || product.title.toLowerCase().indexOf("bell") > -1) {
      isBike = false;
    }
//     guardianAPI.setPrice(variant.price);
    if (product.type == 'Kids Bikes') {
      isBike = true;
    } else {
      isBike = false;
    }
    if (!firstLoad == null) {
    	firstLoad = false;
    }
	guardianAPI.handleChangeImages(product, variant.sku, firstLoad)
	guardianAPI.setPDPInfo(product, variant, firstLoad)
	// guardianAPI.setBundle(product, variant, firstLoad)

    
    // var isNew = document.querySelector('.gb-new-products-sku[data-sku="'+variant.sku+'"]')
    // if (isNew) {
    //   $('.image-gallery-and-icons').addClass('image-gallery-and-icons--new')
    // } else {
    //   $('.image-gallery-and-icons').removeClass('image-gallery-and-icons--new')
    // }

    
//     guardianAPI.hideZipAvailability()
    currentSku = variant.sku;
    // var restockInfo = guardianAPI.setStockStatus(product, variant, isBike);
    var stock = variant.inventory_quantity;
//     var stock = restockInfo.stock
    var formattedPrice = guardianAPI.formatPrice(variant.price)
    // guardianAPI.updatePrice(variant.price)
    var preorderInfo = document.querySelector('.gb-product-info-variant[data-sku="'+variant.sku+'"]'); 
    var preorderDate = preorderInfo && preorderInfo.dataset.preorderDate
    var preorderMax = preorderInfo && preorderInfo.dataset.preorderMax
    var holidayDelivery = preorderInfo && preorderInfo.dataset.holidayDelivery && preorderInfo.dataset.holidayDelivery == 'true'
    var californiaDelivery = preorderInfo && preorderInfo.dataset.californiaDelivery && preorderInfo.dataset.californiaDelivery == 'true'
    var pennsylvaniaDelivery = preorderInfo && preorderInfo.dataset.pennsylvaniaDelivery && preorderInfo.dataset.pennsylvaniaDelivery == 'true'
    var indianaDelivery = preorderInfo && preorderInfo.dataset.indianaDelivery && preorderInfo.dataset.indianaDelivery == 'true'
    var preorderMaxNegative = preorderMax && (0-preorderMax)
    if (stock > 0 || (variant.inventory_policy === "continue" && !preorderDate)) {
      // It is in stock or is a CKD bike
      guardianAPI.getTransitTime(null, californiaDelivery, indianaDelivery, pennsylvaniaDelivery)
      guardianAPI.setInStock();
      $('.being-assembled-date-container').hide()
      $('.being-assembled-label').text('In Stock')
      $('.being-assembled-pretext').text('Get it by')
      $('#zip-availability-container').show()
      $('.header_add_to_cart_btn, .in_page_add_to_cart_btn .AddToCart-price, .header_add_to_cart_btn_new').text("Add to Cart");
      $(".header_add_to_cart_btn, .in_page_add_to_cart_btn, .header_add_to_cart_btn_new").removeClass("cta_sold_out_btn");
      $(".header_add_to_cart_btn, .in_page_add_to_cart_btn, .header_add_to_cart_btn_new").attr('disabled', false) 
      guardianAPI.removeProperty("Type");
      guardianAPI.removeProperty("Ship Date");
      $('.delivery-time-estimate').html('Ships in 1 business day from our USA&nbsp;factory')
      $('.ATC-below--365').hide();
      $('.ATC-below--holiday-delivery').show()
      let zipFieldContainer = document.querySelector('.zip-form-container')
      let zipFieldOpen = zipFieldContainer && document.querySelector('.zip-form-container').classList.contains('zip-form-container-show')
      if (!zipFieldOpen) {
        let zipMain = document.querySelector('.zip-main')
        if (zipMain) {
          zipMain.classList.remove('zip-main-show')
        }
      }
      // $('.gb-guaranteed-holiday-delivery').addClass('gb-guaranteed-holiday-delivery--hide')
      // $('.image-gallery-and-icons').removeClass('image-gallery-and-icons--guarantee')
      // if (holidayDelivery == true) {
      //   $('.gb-guaranteed-holiday-delivery').removeClass('gb-guaranteed-holiday-delivery--hide')
      //   $('.gb-guaranteed-holiday-delivery-text b').text('Delivers Before Christmas')
      //   // $('.image-gallery-and-icons').addClass('image-gallery-and-icons--guarantee')
      //   $('.offer-timer-container').show()
      // } else {
      //   $('.gb-guaranteed-holiday-delivery').addClass('gb-guaranteed-holiday-delivery--hide')
      //   $('.gb-guaranteed-holiday-delivery-text b').text('Delivers After Christmas')
      //   // $('.image-gallery-and-icons').removeClass('image-gallery-and-icons--guarantee')
      //   // $('.offer-timer-container').hide()
      // }
    } else if ((preorderDate && !preorderMaxNegative) || (preorderDate && stock > preorderMaxNegative)) {
      // It is a preorder bike, checks for a max allowed presold when relevant
      console.log("BBBB")
      guardianAPI.hideDeliveryInfo()
      $('.being-assembled-date-ship-text').text(preorderDate)
      $('.being-assembled-date-container').show()
      $('.being-assembled-label').text('Being Assembled')
      $('.being-assembled-pretext').text('Ships')
      if (product.type == 'Kids Bikes') {
        $('#zip-availability-container').hide()
      }
      guardianAPI.removeProperty("Type");
      guardianAPI.addProperty("Type", "Pre-order");
      guardianAPI.removeProperty("Ship Date");
      $('.header_add_to_cart_btn, .in_page_add_to_cart_btn .AddToCart-price, .header_add_to_cart_btn_new').html("Add to Cart");
      // $('.header_add_to_cart_btn, .in_page_add_to_cart_btn').html("Add to Cart "+'<span class="backorder-ship-date-text">(ships '+preorderDate+')</span>');
      $(".header_add_to_cart_btn, .in_page_add_to_cart_btn, .header_add_to_cart_btn_new").removeClass("cta_sold_out_btn");
      $(".header_add_to_cart_btn, .in_page_add_to_cart_btn, .header_add_to_cart_btn_new").attr('disabled', false) 
      // var skuPreorderTextFormatted = preorderDate.replace(/&nbsp;/gi," ")
      guardianAPI.addProperty("Ship Date", preorderDate);
      guardianAPI.setInStock();
//       guardianAPI.hideZipAvailability();
      $('.holiday-delivery-text').text('')
      let firstPartOfSentence = preorderDate.toLowerCase().includes('business') ? 'Ships in ' : 'Ships ';
      $('.delivery-time-estimate').html(firstPartOfSentence+preorderDate+' from our USA factory')
      $('.being-assembled-pretext').html(firstPartOfSentence)
      // if (holidayDelivery == true) {
      //   $('.gb-guaranteed-holiday-delivery').removeClass('gb-guaranteed-holiday-delivery--hide')
      //   $('.gb-guaranteed-holiday-delivery-text b').text('Delivers Before Christmas')
      //   // $('.image-gallery-and-icons').addClass('image-gallery-and-icons--guarantee')
      //   $('.offer-timer-container').show()
      // } else {
      //   // $('.gb-guaranteed-holiday-delivery').addClass('gb-guaranteed-holiday-delivery--hide')
      //   $('.gb-guaranteed-holiday-delivery').removeClass('gb-guaranteed-holiday-delivery--hide')
      //   $('.gb-guaranteed-holiday-delivery-text b').text('Delivers After Christmas')
      //   // $('.image-gallery-and-icons').removeClass('image-gallery-and-icons--guarantee')
      //   // $('.offer-timer-container').hide()
      // }
    } else if (!variant.available || (preorderDate && stock <= preorderMaxNegative)) {
      // It is out of stock
      guardianAPI.hideDeliveryInfo()
      $('.being-assembled-date-container').hide()
      $('#zip-availability-container').hide()
      guardianAPI.removeProperty("Type");
      guardianAPI.addProperty("Type", "Pre-order");
      $('.header_add_to_cart_btn, .header_add_to_cart_btn_new').text('Out of Stock');
      $('.header_add_to_cart_btn, .in_page_add_to_cart_btn .AddToCart-price').text('Out of Stock');
      $(".header_add_to_cart_btn, .in_page_add_to_cart_btn, .header_add_to_cart_btn_new").addClass("cta_sold_out_btn");
      $(".header_add_to_cart_btn, .in_page_add_to_cart_btn, .header_add_to_cart_btn_new").attr('disabled', true) 
      // guardianAPI.setOutOfStock(variant, isBike);
//         guardianAPI.hideZipAvailability();
      $('.holiday-delivery-text').text('')
      $('.ATC-below--365').show();
      $('.ATC-below--holiday-delivery').hide()
      // if (holidayDelivery == true) {
      //   $('.gb-guaranteed-holiday-delivery').removeClass('gb-guaranteed-holiday-delivery--hide')
      //   $('.gb-guaranteed-holiday-delivery-text b').text('Delivers After Christmas')
      //   // $('.image-gallery-and-icons').addClass('image-gallery-and-icons--guarantee')
      //   $('.offer-timer-container').show()
      // } else {
      //   $('.gb-guaranteed-holiday-delivery').addClass('gb-guaranteed-holiday-delivery--hide')
      //   $('.gb-guaranteed-holiday-delivery-text b').text('Delivers After Christmas')
      //   // $('.image-gallery-and-icons').removeClass('image-gallery-and-icons--guarantee')
      //   // $('.offer-timer-container').hide()
      // }
    }
  },
  checkInventory: function (sku, handleUndeliverable) {
    $.ajax({
      url : 'https://docker-boilerplate.herokuapp.com/availableAtBoth/'+sku,
      type : 'GET',
      dataType:'json',
      success : function(data) {
        if (handleUndeliverable) {
          if (data.message === "Not available") {
            //$('.zip-delivery-message-error, .zip-delivery-message-error-mobile').text('Out of stock.');
            $('.zip-delivery-message-text, .zip-delivery-message-text-mobile').text('');
            $('.zip-delivery-message-text, .zip-delivery-message-text-mobile').slideUp(600);
            $('.zip-delivery-message, .zip-delivery-message-mobile').slideDown(600);
            $('.zip-delivery-message-error, .zip-delivery-message-error-mobile').slideDown(600);
          } else {
            //$('.zip-delivery-message-error, .zip-delivery-message-error-mobile').text('Zip code invalid.');
            $('.zip-delivery-message-text, .zip-delivery-message-text-mobile').text('');
            $('.zip-delivery-message-text, .zip-delivery-message-text-mobile').slideUp(600);
            $('.zip-delivery-message, .zip-delivery-message-mobile').slideDown(600);
            $('.zip-delivery-message-error, .zip-delivery-message-error-mobile').slideDown(600);
          }

        } else {
          $('.confirm-delivery-button, .confirm-delivery-button-mobile').show();
//           $('.zip-form-container, .zip-form-container-mobile').show	();
          var zipChecked = $('.delivery-time-span, delivery-time-span-mobile').attr("zip-checked"); 
//           if (data.error === true) {
//             $('.fast-delivery-time, .fast-delivery-time-mobile').slideUp(300, function() {
// 				$('.slow-delivery-time, .slow-delivery-time-mobile').slideDown(300);
// 			});
//           } else if (data.error === false) {
//             $('.slow-delivery-time, .slow-delivery-time-mobile').slideUp(300, function() {
// 				$('.fast-delivery-time, .fast-delivery-time-mobile').slideDown(300);
// 			});
//           }
        }
      },
      error : function(request,error) {      
//         $('.fast-delivery-time, .fast-delivery-time-mobile').slideUp(600);
//         $('.slow-delivery-time, .slow-delivery-time-mobile').slideDown(600);
      }
    });
  },
  getDeliveryDateByZip: function (e) {
	// Deprecated, if reusing zip availability then rewrite without moment library 	
    var zip = document.querySelector("#zip-input").value.trim()
    var selectedVariant = window.variant
    var preorderInfo = document.querySelector('.gb-product-info-variant[data-sku="'+selectedVariant.sku+'"]'); 
    var preorderDate = preorderInfo && preorderInfo.dataset.preorderDate
    var preorderMax = preorderInfo && preorderInfo.dataset.preorderMax
    var holidayDelivery = preorderInfo && preorderInfo.dataset.holidayDelivery && preorderInfo.dataset.holidayDelivery == 'true'
    var californiaDelivery = preorderInfo && preorderInfo.dataset.californiaDelivery && preorderInfo.dataset.californiaDelivery == 'true'
    var pennsylvaniaDelivery = preorderInfo && preorderInfo.dataset.pennsylvaniaDelivery && preorderInfo.dataset.pennsylvaniaDelivery == 'true'
    var indianaDelivery = preorderInfo && preorderInfo.dataset.indianaDelivery && preorderInfo.dataset.indianaDelivery == 'true'
    guardianAPI.getTransitTime(zip, californiaDelivery, indianaDelivery, pennsylvaniaDelivery)
  },
  getVariantTitle: function () {
      var option1 = $('input[name=option-0]').length > 0 && Array.from($('input[name=option-0]')).find(function(each) {return each.checked === true})
      var option2 = $('input[name=option-1]').length > 0 && Array.from($('input[name=option-1]')).find(function(each) {return each.checked === true})
      var option3 = $('input[name=option-2]').length > 0 && Array.from($('input[name=option-2]')).find(function(each) {return each.checked === true})
      if (!option1) {
        return;
      }
      var variantTitle = option1.value.trim()
      if (option2) {
        variantTitle += " / "
        variantTitle += option2.value.trim()
      }
      if (option3) {
        variantTitle += " / "
        variantTitle += option3.value.trim()
      }
    return variantTitle;
  },
  openZipInput: function () {
    if ($('.confirm-delivery-button-text, .confirm-delivery-button-text-mobile').attr("data-confirm-or-hide") === "hide") {
      $('.confirm-delivery-button-text, .confirm-delivery-button-text-mobile').attr({"data-confirm-or-hide": "confirm"})
      $('.zip-form-container, .zip-form-container-mobile').slideUp();
      $('.confirm-delivery-button-text, .confirm-delivery-button-text-mobile').text("Confirm Delivery Date")
    } else {
      $('.confirm-delivery-button-text, .confirm-delivery-button-text-mobile').attr({"data-confirm-or-hide": "hide"})
      $('.zip-form-container, .zip-form-container-mobile').slideDown();
    }
  },
  clearZipError: function () {
    $(".zip-delivery-message").slideUp(500);
    $('.zip-delivery-message-error, .zip-delivery-message-error-mobile').text('');
  },
  handleZipError: function (message) {
    $('.zip-delivery-message-text, .zip-delivery-message-text-mobile').slideUp(600, function() {
      $('.zip-delivery-message-error, .zip-delivery-message-error-mobile').text(message);
      $('.zip-delivery-message, .zip-delivery-message-mobile').slideDown(600);
      $('.zip-delivery-message-error, .zip-delivery-message-error-mobile').slideDown(600);
    });
  },
  handleKeyDown: function (e) {
    if(event.keyCode == 13) {
      event.preventDefault();
//       guardianAPI.getDeliveryDateByZip(e)
      var zip = document.querySelector("#zip-input").value.trim()
      var selectedVariant = window.variant
      var preorderInfo = document.querySelector('.gb-product-info-variant[data-sku="'+selectedVariant.sku+'"]'); 
      var preorderDate = preorderInfo && preorderInfo.dataset.preorderDate
      var preorderMax = preorderInfo && preorderInfo.dataset.preorderMax
      var holidayDelivery = preorderInfo && preorderInfo.dataset.holidayDelivery && preorderInfo.dataset.holidayDelivery == 'true'
      var californiaDelivery = preorderInfo && preorderInfo.dataset.californiaDelivery && preorderInfo.dataset.californiaDelivery == 'true'
      var pennsylvaniaDelivery = preorderInfo && preorderInfo.dataset.pennsylvaniaDelivery && preorderInfo.dataset.pennsylvaniaDelivery == 'true'
      var indianaDelivery = preorderInfo && preorderInfo.dataset.indianaDelivery && preorderInfo.dataset.indianaDelivery == 'true'
      guardianAPI.getTransitTime(zip, californiaDelivery, indianaDelivery, pennsylvaniaDelivery)
      return false;
    }
    return true;
  }
  ,addDays: function (days){
    return new Date(new Date().getTime() + days*24*60*60*1000);
  }
  ,updateCartDate: function (key, date, cartMessage, shipType) {
    
    let properties = {}
    if (shipType) {
      properties['Ship Date'] = date
      properties['Type'] = shipType
    }
    $.ajax({
      url : '/cart/change.js',
      type : 'POST',
      dataType: 'json',
      data: {
        id: key,
        properties: properties
      },
      success : function(cart) {
        ajaxCart.load();
        setTimeout(function () {
          if (cartMessage) {
            $('#AlbarCartContainer').append($('<p style="color: #d43b3b; padding: 10px 15px;">'+cartMessage+'</p>'))
          }
        }, 1000)
      },
      error : function(request,error) {
        console.log(error);
      }
    })
  }
  ,removeCartDate: function (key, cartMessage) {
    $.ajax({
      url : '/cart/change.js',
      type : 'POST',
      dataType: 'json',
      data: {
        id: key,
        properties: {
          'Ship Date': null,
          'Type': null
        }
      },
      success : function(cart) {
        console.log(cart)
        console.log("removed ship date")
        ajaxCart.load();
        setTimeout(function () {
          if (cartMessage) {
            $('#AlbarCartContainer').append($('<p style="color: #d43b3b; padding: 10px 15px;">'+cartMessage+'</p>'))
          }
        }, 1000)
      },
      error : function(request,error) {
        console.log(error);
      }
    })
  }
  ,getCart: function () {
    return new Promise((resolve, reject) => {
      $.ajax({
        url : '/cart?view=alternate.json',
        type : 'GET',
        success : function(data) {
          if (data.error === true ) {
  			console.log("error", data.error)
            reject(data.error)
          } else {
            var jsonData = JSON.parse(data)
            resolve(jsonData)
          }
        }
      })
    })
  }
  ,watchCart: async function () {

    let cart = await guardianAPI.getCart()
    var cartItems = cart.items
    // var productIds = cartItems.map(function(cartItems) {return cartItems.id})
    // let inventoryData = await guardianAPI.getInventoryForProducts(productIds)



         
          
    for (var i=0;i<cartItems.length;i++) {
      // Get current preorder/backorder info if there is any
      var cartItem = cartItems[i]
      var previousDate = cartItem.properties["Ship Date"] == '' || cartItem.properties["Ship Date"] == undefined ? null : cartItem.properties["Ship Date"]
      var currentDate = cartItem.preorder_date
      var preorderMax = cartItem.preorder_max
      var preorderMaxNegative = preorderMax && (0-preorderMax)
      var available = cartItem.available
      var inventoryPolicy = cartItem.inventory_policy
      var previousShipType = cartItem.properties["Type"]

      
      if (previousDate !== null && previousDate !== currentDate && available > 0) {
        console.log("previousDate", previousDate)
        console.log("currentDate", currentDate)
        console.log("available", available)
        guardianAPI.removeCartDate(cartItem.key, "Some items in your cart are back in stock.")
      } else if (currentDate && preorderMax && available <= preorderMaxNegative) {
        guardianAPI.removeCartItem(cartItem, cartItem.title+" is no longer available")
      } else if (!currentDate && available <= 0 && inventoryPolicy == "deny") {
        guardianAPI.removeCartItem(cartItem, cartItem.title+" is no longer available")
      } else if (previousDate !== currentDate && available <= 0) {
        guardianAPI.updateCartDate(cartItem.key, currentDate, "Some items in your cart have changed their expected ship dates.", "Pre-order")
      }
    }

    
  }
  ,toHandle(value) {
    return value.toLowerCase().replaceAll(/'/g, "").replaceAll(/\s+/g, "-")
  }
  ,addRecommendedAccesoriesToCart(bikeProduct, recommendedProducts, totalAccessoriesValue, hasBike, cart, activeUpsellItemId) {
    var cartItems = cart.items
    var bikeCount = cart.items.filter(function(each) {return each.product_type == 'Kids Bikes'}).length
//     var bell1 = filteredBellsToShow[0] ? `<div class="recommended-accessory-container"><div class="recommended-accessory"><div class="recommended-accessory-main"><img src="${filteredBellsToShow[0].variant.image.url}"/><a class="recommended-accessory-title" href="/products/${filteredBellsToShow[0].product.handle}?variant=${filteredBellsToShow[0].id}"><p><b>${filteredBellsToShow[0].product.title}</b></p></a><p>${filteredBellsToShow[0].variant.title}</p></div><div class="recommended-accessory-footer"><p class="recommended-accessory-price">+$${filteredBellsToShow[0].variant.price}</p><a class="recommended-accessory-atc" data-id="${filteredBellsToShow[0].variant.id}">+ Add</a></div></div></div>` : '' ;
//     var bell2 = filteredBellsToShow[1] ? `<div class="recommended-accessory-container"><div class="recommended-accessory"><div class="recommended-accessory-main"><img src="${filteredBellsToShow[1].variant.image.url}"/><a class="recommended-accessory-title" href="/products/${filteredBellsToShow[1].product.handle}?variant=${filteredBellsToShow[1].id}"><p><b>${filteredBellsToShow[1].product.title}</b></p></a><p>${filteredBellsToShow[1].variant.title}</p></div><div class="recommended-accessory-footer"><p class="recommended-accessory-price">+$${filteredBellsToShow[1].variant.price}</p><a class="recommended-accessory-atc" data-id="${filteredBellsToShow[1].variant.id}">+ Add</a></div></div></div>` : '' ;
//     var bell3 = filteredBellsToShow[2] ? `<div class="recommended-accessory-container"><div class="recommended-accessory"><div class="recommended-accessory-main"><img src="${filteredBellsToShow[2].variant.image.url}"/><a class="recommended-accessory-title" href="/products/${filteredBellsToShow[2].product.handle}?variant=${filteredBellsToShow[2].id}"><p><b>${filteredBellsToShow[2].product.title}</b></p></a><p>${filteredBellsToShow[2].variant.title}</p></div><div class="recommended-accessory-footer"><p class="recommended-accessory-price">+$${filteredBellsToShow[2].variant.price}</p><a class="recommended-accessory-atc" data-id="${filteredBellsToShow[2].variant.id}">+ Add</a></div></div></div>` : '' ;
    var allAccessories = recommendedProducts.filter(function(recommendedProduct) {
      if (!recommendedProduct) {
        return false
      }
      var recommendedProductNode = recommendedProduct
      var recommendedProductVariants = recommendedProductNode.variants.edges
      if (!recommendedProductVariants.length) {
        return false
      }
      return recommendedProduct != undefined
    }).map(function(recommendedProduct) {
      var recommendedProductNode = recommendedProduct
      var isHelmet = recommendedProductNode.handle == 'kids-bike-helmets'
      var isBell = recommendedProductNode.handle == 'guardian-bike-bell'
      var recommendedProductVariants = recommendedProductNode.variants.edges
      if (!recommendedProductVariants.length) {
        return false
      }
      var recommendedProductVariantFirst = recommendedProductVariants.length && recommendedProductVariants[0].node
      var recommendedProductVariantFirstId = recommendedProductVariantFirst && recommendedProductVariantFirst.id.replace('gid://shopify/ProductVariant/', '')
      var variantSwatches = recommendedProductVariants.filter(function(recommendedProductVariant) {
        var recommendedProductVariantNode = recommendedProductVariant.node
        var preorderDate = recommendedProductVariantNode.preorder_date && recommendedProductVariantNode.preorder_date.value
        var preorderMax = recommendedProductVariantNode.preorder_max && recommendedProductVariantNode.preorder_max.value
        var preorderMaxNegative = preorderMax && (0-preorderMax)
        var available = recommendedProductVariantNode.quantityAvailable
        if (preorderDate && !preorderMax) {
          return true;
        } else if (preorderDate && stock > preorderMaxNegative) {
          return true;
        } else if (preorderDate && stock <= preorderMaxNegative) {
          return false;
        } else {
          return true;
        }
      }).slice(0, 3).map(function(recommendedProductVariant, recommendedProductVariantIndex) {
        var recommendedProductVariantNode = recommendedProductVariant.node
        var preorderDate = recommendedProductVariantNode.preorder_date && recommendedProductVariantNode.preorder_date.value
        var swatchImgUrl
        if (isHelmet) {
          swatchImgUrl = `https://cdn.shopify.com/s/files/1/1030/6965/files/kids-bike-helmets-${guardianAPI.toHandle(recommendedProductVariantNode.selectedOptions[1].value)}_100x100_crop_center.png?v=1654706018`
        } else if (isBell) {
          swatchImgUrl = `https://cdn.shopify.com/s/files/1/1030/6965/files/guardian-bike-bell-${guardianAPI.toHandle(recommendedProductVariantNode.selectedOptions[0].value)}_100x100_crop_center.jpg?v=1654706018`
        } else {
          var colorOptionIndex = recommendedProductVariantNode.selectedOptions.findIndex(function(each) {return each.name == 'Color'})
          if (colorOptionIndex > -1) {
            swatchImgUrl = `https://cdn.shopify.com/s/files/1/1030/6965/files/${recommendedProductNode.handle}-${guardianAPI.toHandle(recommendedProductVariantNode.selectedOptions[colorOptionIndex].value)}_100x100_crop_center.png`
          } else {
            swatchImgUrl = `https://cdn.shopify.com/s/files/1/1030/6965/files/${recommendedProductNode.handle}_100x100_crop_center.png`
          }
        }
        return `<div class="recommended-accessory-swatch ${recommendedProductVariantIndex == 0 ? "recommended-accessory-swatch--selected" : ""}" data-id="${recommendedProductVariantNode.id}" data-img="${recommendedProductVariantNode.image.url}" data-variant-title="${recommendedProductVariantNode.title}" data-price="${recommendedProductVariantNode.price.amount}" data-sku="${recommendedProductVariantNode.sku}" ${preorderDate ? `data-preorder-date="${preorderDate}"` : ""} data-hide-options="${recommendedProductNode.tags.includes('hide_options')}">
					<img class="recommended-accessory-swatch-img" src="${swatchImgUrl}" />
                </div>`
      })
      // var pricingHtml = isBlackFriday ? `<p class="recommended-accessory-compare-price"><strike>$${recommendedProductVariantFirst.price.amount}</strike></p>
      //                                   <p class="recommended-accessory-price">$${(parseFloat(recommendedProductVariantFirst.price.amount)*.85).toFixed(2)}</p>`
      //                                 : `<p class="recommended-accessory-price">$${(parseFloat(recommendedProductVariantFirst.price.amount)).toFixed(2)}</p>`
      var pricingHtml = `<p class="recommended-accessory-price">+$${(parseFloat(recommendedProductVariantFirst.price.amount)).toFixed(2)}</p>`
      var preorderDate = recommendedProductVariantFirst.preorder_date && recommendedProductVariantFirst.preorder_date.value
      var preorderText = preorderDate ? `Ships ${preorderDate}` : "";
      var upsellNote = recommendedProductVariantFirst.upsell_note && recommendedProductVariantFirst.upsell_note.value ? recommendedProductVariantFirst.upsell_note.value : recommendedProduct.upsell_note && recommendedProduct.upsell_note.value ? recommendedProduct.upsell_note.value : ""
      return `
<div class="recommended-accessory-container">
  <div class="recommended-accessory">
    <div class="recommended-accessory-main">
      <img class="recommended-accessories-main-img" src="${recommendedProductVariantFirst.image.url}"/>
      <div class="recommended-accessory-inner">
        <div class="recommended-accessory-inner-left">
              <a class="recommended-accessory-title" href="/products/${recommendedProductNode.handle}${recommendedProductVariantFirstId ? "?variant="+recommendedProductVariantFirstId : ""}">
              <p><b>${recommendedProductNode.title}</b></p>
              </a>
              ${recommendedProductVariants.length == 1 ? `<p class="recommended-accessory-variant-title recommended-accessory-variant-title--hidden">${recommendedProductVariantFirst.title}</p>` : `<p class="recommended-accessory-variant-title recommended-accessory-variant-title--hidden">${recommendedProductVariantFirst.title}</p>`}
              ${`<div class="recommended-accessory-note recommended-accessory-note--mobile">${upsellNote}</div>`}
              <div class="recommended-accessory-swatches ${recommendedProductVariants.length == 1 ? "recommended-accessory-swatches--hidden" : ''}">
                ${recommendedProductVariants.length == 1 ? "" : variantSwatches.join('\n')}
              </div>
        </div>
         <div><p class="recommended-accessory-preorder">${preorderText}</p></div>
        <div class="recommended-accessory-inner-right">
          <div class="recommended-accessory-footer">
            <div class="recommended-accessory-price-container">
              ${pricingHtml}
            </div>
            <a class="recommended-accessory-atc" data-id="${parseInt(recommendedProductVariantFirst.id.replace('gid://shopify/ProductVariant/', ''))}" ${preorderDate ? `data-date="${preorderDate}"` : ""}>+ Add</a>
          </div>
        </div>
      </div>
    </div>
      ${`<div class="recommended-accessory-note recommended-accessory-note--desktop">${upsellNote}</div>`}
  </div>
</div>`


              // <p class="recommended-accessory-compare-price"><strike>$${recommendedProductVariantFirst.price}</strike></p>
              // <p class="recommended-accessory-price">$${(parseFloat(recommendedProductVariantFirst.price)*.85).toFixed(2)}</p>
      
    })
    //       var bell2 = filteredBellsToShow[1] ? `<a class="recommended-bell" type="submit" name="add" class="recommended-bell" data-id="${filteredBellsToShow[1].id}"><img src="https://cdn.shopify.com/s/files/1/1030/6965/files/${filteredBellsToShow[1].image}"/></a>` : '' ;
//       var bell3 = filteredBellsToShow[2] ? `<a class="recommended-bell" type="submit" name="add" class="recommended-bell" data-id="${filteredBellsToShow[2].id}"><img src="https://cdn.shopify.com/s/files/1/1030/6965/files/${filteredBellsToShow[2].image}"/></a>` : '' ;
//     var message = $(`
// 			<div class="recommended-accessories-header">
// 				<p>Others also bought</p>
// 			</div>
// 			<div class="recommended-accessories-main">
//                   ${bell1}
//                   ${bell2}
//                   ${bell3}
// 			</div>`)
// ${totalAccessoriesValue >= 2900 ? "<p>Free Shipping Unlocked &check;</p>" : "<p>Add $29 of accessories to unlock free&nbsp;shipping!</p>"}
    var recommendedAccessoriesItems = cartItems.filter(function(cartItem) {return cartItem.product_type === 'Kids Bikes'}).map(function(cartItem) {
      return `<label class="recommended-accessories-item ${cartItem.id == activeUpsellItemId ? "recommended-accessories-item--selected": ""}">
                <p class="recommended-accessories-item--product_title">${cartItem.product_title}</p>
                <p class="recommended-accessories-item--variant_title">${cartItem.variant_title}</p>
                <input type="radio" id="${cartItem.id}" name="recommended-accessories-for" value="${cartItem.id}" ${cartItem.id == activeUpsellItemId ? 'checked="checked"': ""}>
              </label>`
      // return `<div class="recommended-accessories-item ${cartItem.id == activeUpsellItemId.id ? "recommended-accessories-item--selected": ""}">
      //           <p class="recommended-accessories-item--product_title">${cartItem.product_title}</p>
      //           <p class="recommended-accessories-item--variant_title">${cartItem.variant_title}</p>
      //         </div>`
    })
    var message = $(`
			<div class="recommended-accessories-header recommended-accessories-header--${bikeCount}">
                 <div class="free-shipping-with-accessories ${!hasBike ? "free-shipping-with-accessories--hidden" : ""}">
                   <p>Accessories ship free with bikes</p>
                 </div>
				<p class="recommended-accessories-header-text">Shop Accessories for:</p>
                <div class="recommended-accessories-items">
                  ${recommendedAccessoriesItems.join(' ')}
                </div>
			</div>
			<div class="recommended-accessories-main">
                  ${allAccessories.join(' ')}
			</div>`)
//       message.insertBefore('#ajax-cart-instructions')
    $('#ajax-cart-upsell-desktop, #ajax-cart-upsell-mobile').html(message)
    

    $('input[type=radio][name=recommended-accessories-for]').change(function(event) {
      guardianAPI.afterCartCallback(cart, event.target.id)
    });
    
    $('.recommended-accessory-atc').click(function(event) {
      event.preventDefault();
      if (event.currentTarget.hasAttribute('data-disabled')) {
      	return;
      }
      var preorderDate = event.currentTarget.getAttribute('data-date')
      var bellId = event.currentTarget.dataset.id
      var properties = preorderDate ? {'Ship Date': preorderDate, 'Type': "Pre-order", '_ATC': "Cart"} : {'_ATC': "Cart"}
      console.log("properties", properties)
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: bellId,
          properties: properties
        },
        dataType: 'json',
        complete: function(response) {
          ajaxCart.load();
          if (ga) {
            ga('send', 'event', 'Cart', 'Add to Cart - Accessory')
          }
        }
      })
    });
    $('.recommended-accessory-swatch').click(function(event) {
      event.preventDefault();
      if (event.currentTarget.hasAttribute('data-disabled')) {
      	return;
      }
      var accessoryId = event.currentTarget.dataset.id.replace('gid://shopify/ProductVariant/', '')
      var accessoryImg = event.currentTarget.dataset.img
      var accessoryVariantTitle = event.currentTarget.dataset.variantTitle
      var hideOptions = event.currentTarget.dataset.variantTitle
      var accessoryComparePrice = event.currentTarget.dataset.price
      var accessorySku = event.currentTarget.dataset.sku
      var preorderDate = event.currentTarget.dataset.preorderDate
      var recommendedAccessoryContainer = event.currentTarget.closest('.recommended-accessory')
      recommendedAccessoryContainer.querySelectorAll('.recommended-accessory-swatch').forEach(function(each) {
      	each.classList.remove('recommended-accessory-swatch--selected')
      })
      event.currentTarget.classList.add('recommended-accessory-swatch--selected')
      recommendedAccessoryContainer.querySelector(".recommended-accessories-main-img").src = accessoryImg
      recommendedAccessoryContainer.querySelector(".recommended-accessory-atc").dataset.id = accessoryId
      if (hideOptions !== 'true') {
        recommendedAccessoryContainer.querySelector(".recommended-accessory-variant-title").innerText = accessoryVariantTitle
      }
      if (preorderDate) {
        recommendedAccessoryContainer.querySelector('.recommended-accessory-preorder').innerHTML = 'Ships '+preorderDate
        recommendedAccessoryContainer.querySelector('.recommended-accessory-atc').setAttribute('data-date', preorderDate.replace(/&nbsp;/gi," "))
      } else {
        recommendedAccessoryContainer.querySelector('.recommended-accessory-preorder').innerHTML = ''
        recommendedAccessoryContainer.querySelector('.recommended-accessory-atc').removeAttribute('data-date')
      }
      if (isBlackFriday) {
        // var accessoryPrice = parseFloat(event.currentTarget.dataset.price*.85).toFixed(2)
        var accessoryPrice = parseFloat(event.currentTarget.dataset.price).toFixed(2)
        var accessoryComparePrice = event.currentTarget.dataset.price
        recommendedAccessoryContainer.querySelector(".recommended-accessory-price").innerText = "+$"+accessoryPrice
        // recommendedAccessoryContainer.querySelector(".recommended-accessory-compare-price strike").innerText = "+$"+accessoryComparePrice
      } else {
        var accessoryPrice = parseFloat(event.currentTarget.dataset.price).toFixed(2)
        recommendedAccessoryContainer.querySelector(".recommended-accessory-price").innerText = "+$"+accessoryPrice
      }
    });

    const recommendedAccessoriesMain = document.querySelector("#ajax-cart-upsell-mobile .recommended-accessories-main");
    const recommendedAccessoriesLink = recommendedAccessoriesMain.querySelectorAll("a");

    let startX, startY, walkX;
    let scrollTop, scrollLeft;
    let isDown;

    recommendedAccessoriesMain.addEventListener("mousedown", (e) => mouseIsDown(e));
    recommendedAccessoriesMain.addEventListener("mouseup", (e) => mouseUp(e));
    window.addEventListener("mouseup", (e) => mouseUp2(e));
    recommendedAccessoriesMain.addEventListener("mouseleave", (e) => mouseLeave(e));
    recommendedAccessoriesMain.addEventListener("mousemove", (e) => mouseMove(e));

      function mouseIsDown(e) {
        console.log("????????????")
        walkX = 0;
        recommendedAccessoriesMain.classList.add("is-being-dragged")
        isDown = true;
        startX = e.pageX - recommendedAccessoriesMain.offsetLeft;
        scrollLeft = recommendedAccessoriesMain.scrollLeft;
        recommendedAccessoriesLink.forEach(function(each) {
          if (each.href) {
        	each.dataset.link = each.href
          }
          each.dataset.disabled = true
          each.removeAttribute('href')
        })
      }
      function mouseUp(e) {
        recommendedAccessoriesMain.classList.remove("is-being-dragged")
        isDown = false;
        recommendedAccessoriesLink.forEach(function(each) {
          if (each.dataset.link) {
            if (Math.abs(walkX) < 5) {
                each.href = each.dataset.link
            } else {
              setTimeout(function() {
                each.href = each.dataset.link
              }, 20)
            }
          }
          if (each.hasAttribute('data-disabled')) {
            if (Math.abs(walkX) < 5) {
              each.removeAttribute('data-disabled')
            } else {
              setTimeout(function() {
                each.removeAttribute('data-disabled')
              }, 20)
            }
          }
          
        })
      }
      function mouseUp2(e) {
        recommendedAccessoriesMain.classList.remove("is-being-dragged")
      }
      function mouseLeave(e) {
        isDown = false;
      }
      function mouseMove(e) {
        if (isDown) {
          e.preventDefault();
          const x = e.pageX - recommendedAccessoriesMain.offsetLeft;
          walkX = (x - startX);
          recommendedAccessoriesMain.scrollLeft = scrollLeft - walkX;
        }
      }

  }
  ,addFreeText: function() {
    var totalDiscounts = 0;
    var orderTotal = $('#AlbarCartContainer .albar_ajaxcart__footer .aj_cart_subtotal_value')
    var orderTotalValue = parseInt(orderTotal.text().replace('$', ''))
    $('.albar_ajaxcart__product-meta').each(function(k, v) {
      if (v.innerHTML.slice(0,5) == 'Free:') {
        var hasStrikethrough = $('.ajaxcart-item__price-strikethrough', $(v).closest('.albar_grid__item'))
        console.log("hasStrikethrough.length", hasStrikethrough.length)
        if (!hasStrikethrough.length) {
          return
        }
        var discountsOnLine = $('.albar_display-table .text-right span', $(v).closest('.albar_grid__item'))
        var discountsOnLineValue = parseInt(discountsOnLine.text().replace('$', ''))
        totalDiscounts += discountsOnLineValue
        discountsOnLine.text("Free")
//         $(v).closest('.albar_ajaxcart__row').append('<p style="padding: 20px 20px 0;font-weight: bold; font-size: 16px; text-align: center; margin: 0;">This item will be free at checkout</p>')
      }
    })
//     if (totalDiscounts > 0) {
//       var newOrderTotalValue = orderTotalValue - totalDiscounts
//       orderTotal.text('$'+newOrderTotalValue)
//     }
  }
  ,showRecommendedProducts: function (bikeProduct, bikeVariantId, cartAccessories, cart, activeUpsellItemId) {
    if (!bikeProduct) {
      document.querySelector('.albar-drawer--inner-right').style.display = "none";
      document.querySelector('.albar-drawer--right').classList.add("albar-drawer--right--small")
      return;
    }
	var query = `
query getRecommendedProducts {
  product(id: "gid://shopify/Product/${bikeProduct.product_id}") {
    title
	handle
    recommended_helmet_sizes: metafield(namespace: "global", key: "recommended_helmet_sizes") {
      value
    }
    recommended_products: metafield(namespace: "global", key: "recommended_products") {
      value
    }
    variants(first: 12) {
      edges {
        node {
          id
          sku
          recommended_variants: metafield(namespace: "global", key: "recommended_variants") {
            value
          }
          recommended_variants_for_variant: metafield(namespace: "global", key: "recommended_variants_for_variant") {
            value
          }
          recommended_bells: metafield(namespace: "global", key: "recommended_bells_v2") {
            value
          }
          recommended_helmets: metafield(namespace: "global", key: "recommended_helmets") {
            value
          }
        }
      }
    }
  }
}
	`;
    
    $.ajax({
      url : 'https://guardian-bikes.myshopify.com/api/2022-04/graphql.json',
      type : 'POST',
      crossDomain : true,
      dataType: 'json',
      contentType: "application/json",
      //       data: JSON.stringify({query: 'query getRecommendedAccessoriess {  bikes: product(id: "gid://shopify/Product/'+bikeProductId+'") {    title, variants(first: 9) {			edges {        node {  id  sku          metafield(namespace: "global", key: "'+metafieldKey+'") {            value          }        }      }    }}  accessories: product(id: "gid://shopify/Product/'+recommendedProductId+'") {    tags, title, handle, variants(first: 40) {			edges {        node {          id, sku, title, price, compareAtPrice, selectedOptions { name, value }        }      }    }}}'}),
      data: JSON.stringify({query: query}),
      //       data: JSON.stringify({"query":"{shop{name}}"}),
      headers: {
        'X-Shopify-Storefront-Access-Token': '20ac6b449e03222e95bb58e6b83e3abf',
      },
      success : function(data) {
        var recommendedHelmetSizes = data.data.product.recommended_helmet_sizes && JSON.parse(data.data.product.recommended_helmet_sizes.value)
        var currentVariant = data.data.product.variants.edges.find(function(variant) {
        	return variant.node.id.indexOf(bikeVariantId) > -1
        })
        
        var recommendedVariantIds = currentVariant && currentVariant.node.recommended_variants && JSON.parse(currentVariant.node.recommended_variants.value)
        var recommendedBells = currentVariant && currentVariant.node.recommended_bells && JSON.parse(currentVariant.node.recommended_bells.value)
        var recommendedHelmets = currentVariant && currentVariant.node.recommended_helmets && JSON.parse(currentVariant.node.recommended_helmets.value)
        var recommendedProductsIds = JSON.parse(data.data.product.recommended_products.value)
        // var recommendedVariantIds = JSON.parse(data.data.product.recommended_products.value)
        var productQueryIds = recommendedProductsIds.map(function(each) {
          var strippedId = each.replace("gid://shopify/Product/", "")
          return "id:"+strippedId
        }).join(' OR ');
        
        var query2 = `
query getProducts {
products: nodes(ids: ${JSON.stringify(recommendedProductsIds).replaceAll(`'`, `"`)}) {
    ... on Product {
    
        id
        title
		handle
		tags
        upsell_note: metafield(namespace: "global", key: "upsell_note") {
          value
        }
        variants(first: 40) {
          edges {
            node {
              id
              sku
              title
              price {
                amount
              }
			  quantityAvailable
              availableForSale
              image {
                id
                url(transform: {maxWidth: 375})
              }
              compareAtPrice {
                amount
              }
              selectedOptions {
                name
                value
              }
              preorder_date: metafield(namespace: "global", key: "preorder_date") {
                value
              }
              upsell_note: metafield(namespace: "global", key: "upsell_note") {
                value
              }
            }
          }
        }
      
    }
  }
  ${recommendedVariantIds ? `variants: nodes(ids: ${JSON.stringify(recommendedVariantIds).replaceAll(`'`, `"`)}) {
    ... on ProductVariant {
      id
      sku
      title
      price {
        amount
      }
      quantityAvailable
      availableForSale
      image {
        id
        url(transform: {maxWidth: 375})
      }
      compareAtPrice {
        amount
      }
      selectedOptions {
        name
        value
      }
      preorder_date: metafield(namespace: "global", key: "preorder_date") {
        value
      }
      upsell_note: metafield(namespace: "global", key: "upsell_note") {
        value
      }
      product {
        id
        title
        handle
        tags
        upsell_note: metafield(namespace: "global", key: "upsell_note") {
          value
        }
      }
    }
  }` : ``}
}

`
        $.ajax({
          url : 'https://guardian-bikes.myshopify.com/api/2022-04/graphql.json',
          type : 'POST',
          crossDomain : true,
          dataType: 'json',
          contentType: "application/json",
          //       data: JSON.stringify({query: 'query getRecommendedAccessoriess {  bikes: product(id: "gid://shopify/Product/'+bikeProductId+'") {    title, variants(first: 9) {			edges {        node {  id  sku          metafield(namespace: "global", key: "'+metafieldKey+'") {            value          }        }      }    }}  accessories: product(id: "gid://shopify/Product/'+recommendedProductId+'") {    tags, title, handle, variants(first: 40) {			edges {        node {          id, sku, title, price, compareAtPrice, selectedOptions { name, value }        }      }    }}}'}),
          data: JSON.stringify({query: query2}),
          //       data: JSON.stringify({"query":"{shop{name}}"}),
          headers: {
            'X-Shopify-Storefront-Access-Token': '20ac6b449e03222e95bb58e6b83e3abf',
          },
          success : function(data) {
            var recommendedProducts = data.data.products
            var recommendedVariants = data.data.variants
            var recommendedProductsFromVariants = recommendedVariants ? recommendedVariants.filter(function(recommendedVariant) {
              if (!recommendedVariant) {
                return null
              } else {
                return recommendedVariant
              }
            }).map(function(recommendedVariant) {
              if (!recommendedVariant) {
                return 
              }
              var tempProduct = recommendedVariant.product
              tempProduct.variants = {}
              tempProduct.variants.edges = [{node: recommendedVariant}]
              return tempProduct
            }) : []
            var recommendedProductsFromVariantsIds = recommendedVariants ? recommendedProductsFromVariants.map(function(each) {return each.id}) : [];
            var combinedIds = [...recommendedProductsFromVariantsIds, ...recommendedProductsIds]

            var recommendedProductsAndVariants = [...recommendedProductsFromVariants, ...recommendedProducts].filter(function(each){return each != null})


            let recommendedProductsInStockBefore = recommendedProductsAndVariants.filter(function (recommendedProduct) {
              let hasInStock = recommendedProduct.variants.edges.filter(function(variant, variantIndex) {
                var variantStock = 0;
                var variantStockAvailable = variant.node.quantityAvailable
                if (variantStockAvailable) {
                  variantStock = variantStockAvailable
                }
                // return (variantStock > 0)
                return variant.node.availableForSale
              })
              let isHelmet = ["giro-hale-helmet", "giro-scamp-helmet", "kids-bike-helmets"].some(function(each) {return each == recommendedProduct.handle})
              // let isHelmet = recommendedProduct.handle.toLowerCase().indexOf('helmet') > -1
              if (isHelmet) {
                let hasHelmetInSize = recommendedProduct.variants.edges.some(function (variant) {
                  return recommendedHelmetSizes.some(function (recommendedHelmetSize) {
                    return variant.node.selectedOptions[0].value == recommendedHelmetSize
                  })
                })
                if (hasHelmetInSize) {
                  return true
                } else {
                  return false
                }
                
              } else {
                return hasInStock.length > 0
              }
            })
            var recommendedProductsInStock = recommendedProductsInStockBefore.map(function(each) {
              var inStockVariants = each.variants.edges.filter(function(variant, variantIndex) {                var variantStock = 0;
                var variantStockAvailable = variant.node.quantityAvailable
                if (variantStockAvailable) {
                  variantStock = variantStockAvailable
                }
                // return (variantStock > 0)
                return variant.node.availableForSale
              });
              each.variants.edges = inStockVariants;
              return each;
            })
            
            var helmetProductIndexes = [];
            recommendedProductsInStock.forEach(function(recommendedProduct, recommendedProductIndex) {
              let isHelmet = ["giro-hale-helmet", "giro-scamp-helmet", "kids-bike-helmets"].some(function(each) {return each == recommendedProduct.handle})
              if (isHelmet) {
                helmetProductIndexes.push(recommendedProductIndex)
              }
            })
            var bellProductIndex = recommendedProductsInStock.findIndex(function(recommendedProduct) {
              return recommendedProduct.handle == 'guardian-bike-bell'
            })

            // Filters for recommended helmet sizes in the first option
            if (recommendedHelmetSizes && helmetProductIndexes.length) {

              helmetProductIndexes.forEach(function(helmetProductIndex) {
                var filteredHelmets = recommendedProductsInStock[helmetProductIndex].variants.edges.filter(function (variant) {
                  return recommendedHelmetSizes.some(function (recommendedHelmetSize) {
                    return variant.node.selectedOptions[0].value == recommendedHelmetSize
                  })
                })
                recommendedProductsInStock[helmetProductIndex].variants.edges = filteredHelmets
              })
              

            
            }
            

            // Filter bells by preferred SKUs
            
            if (bellProductIndex > -1 && recommendedBells) {
              var recommendedBellsReverse = recommendedBells.reverse()
              recommendedBellsReverse.forEach(function (recommendedBell) {
                var currentBellIndex = recommendedProductsInStock[bellProductIndex].variants.edges.findIndex(function(each) {
                  return each.node.sku == recommendedBell
                })
                if (currentBellIndex > -1) {
                  var currentBellVariant = recommendedProductsInStock[bellProductIndex].variants.edges.splice(currentBellIndex, 1)[0]
                  recommendedProductsInStock[bellProductIndex].variants.edges.unshift(currentBellVariant)
                }
              })
            }
            // Filter helmets by preferred SKUs
            if (helmetProductIndexes.length && recommendedHelmets) {

              helmetProductIndexes.forEach(function (helmetProductIndex) {

                var recommendedHelmetsReverse = recommendedHelmets.reverse()
                recommendedHelmetsReverse.forEach(function (recommendedBell) {
                  var helmetVariantIndex = recommendedProductsInStock[helmetProductIndex].variants.edges.findIndex(function(each) {
                    return each.node.sku == recommendedBell
                  })
                  if (helmetVariantIndex > -1) {
                    var currentBellVariant = recommendedProductsInStock[helmetProductIndex].variants.edges.splice(helmetVariantIndex, 1)[0]
                    recommendedProductsInStock[helmetProductIndex].variants.edges.unshift(currentBellVariant)
                  }
                })
              })
              

            }
            // Remove accessories if they are already in cart
            if (helmetProductIndexes.length && cartAccessories.helmet == true) {
              // recommendedProductsInStock.splice(helmetProductIndex, 1); 
              let productsWithoutHelmets = recommendedProductsInStock.filter(function(each, eachIndex) {
                return helmetProductIndexes.indexOf(eachIndex) > -1
              }); 
            }
            if (bellProductIndex > -1 && cartAccessories.bell == true) {
              recommendedProductsInStock.splice(bellProductIndex, 1); 
            }
            var filteredRecommendedProductsInStock  = recommendedProductsInStock.filter(function(each) {
              var hasItem = cart.items.find(function(item) {
                return each.handle.indexOf(item.handle) > -1
              })
              if (!hasItem) {
                return true;
              }
            })
            var sortedFilteredRecommendedProductsInStock = combinedIds.map(function(recommendedProductsId) {
              var sortedProduct = filteredRecommendedProductsInStock.find(function(each) {
                return each.id == recommendedProductsId;
              })
              return sortedProduct;
            })

            var totalAccessoriesValue = 0;
            cart.items.forEach(function(item) {
              if (item.product_type != 'Kids Bikes') {
                totalAccessoriesValue += item.line_price
              }
            })
            var hasBike = cart.items.some(function(item) {return item.product_type == 'Kids Bikes'})
            
            if (sortedFilteredRecommendedProductsInStock.length) {
              guardianAPI.addRecommendedAccesoriesToCart(bikeProduct, sortedFilteredRecommendedProductsInStock, totalAccessoriesValue, hasBike, cart, activeUpsellItemId)
              document.querySelector('.albar-drawer--inner-right').style.display = "block";
              document.querySelector('.albar-drawer--right').classList.remove("albar-drawer--right--small")
            } else {
              document.querySelector('.albar-drawer--inner-right').style.display = "none";
              document.querySelector('.albar-drawer--right').classList.add("albar-drawer--right--small")
              
            }
          }
        })
      }
    })


  }
  ,gtag_report_conversion_add_to_cart: function (line_item) {
    if (line_item.product_type == 'Kids Bikes') {
      if (typeof ga === 'function') {
        ga('send', 'event', 'Cart', 'Add to Cart - Bike')
      }
      var callback = function () {
        if (typeof(url) != 'undefined') {
          window.location = url;
        }
      };
      if (typeof gtag === 'function') {
        gtag("event", "add_to_cart", {
          currency: "USD",
          value: line_item.final_line_price,
          items: [
            {
              item_id: line_item.sku,
              item_name: line_item.title,
              affiliation: "Shopify Shopping Cart",
              discount: line_item.line_level_total_discount,
              item_category: line_item.product_type,
              item_variant: line_item.variant_id,
              price: line_item.final_price/100,
              quantity: line_item.quantity
            }
          ]
        });
      }
    } else if (['Helmets', 'Bells', 'Accessories'].indexOf(line_item.product_type) > -1) {
      if (typeof ga === 'function') {
        ga('send', 'event', 'Cart', 'Add to Cart - Accessory')
      }
    
    }
  }
  ,gb_report_conversion_add_to_cart: function(line_item) {
    if (snowplow) {
      // Fetch cart token
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartToken = cart.token;
          
          // Build cart context
          const context = [{
            schema: "iglu:com.shopify/cart/jsonschema/1-0-0",
            data: {
              id: cartToken,
              token: cartToken
            }
          }];
          
          // Track add to cart with context
          snowplow('trackAddToCart', {
            sku: line_item.sku, 
            name: line_item.title, 
            category: line_item.product_type, 
            unitPrice: line_item.final_price/100, 
            quantity: 1, 
            currency: 'USD',
            context: context
          });
        })
        .catch(error => {
          console.error('Error fetching cart token:', error);
          // Still track the event even if cart fetch fails
          snowplow('trackAddToCart', {
            sku: line_item.sku, 
            name: line_item.title, 
            category: line_item.product_type, 
            unitPrice: line_item.final_price/100, 
            quantity: 1, 
            currency: 'USD'
          });
        });
    }
  }
  ,segment_report_conversion_add_to_cart: function(line_item) {
    if (typeof analytics === 'undefined') {
      console.log("segment not loaded")
    } else {
      console.log("line_item", line_item)
      analytics.track('Add To Cart', {
        product_id: line_item.product_id,
        name: line_item.title,
        quantity: 1,
        price: line_item.final_price/100,
        url: 'https://www.guardianbikes.com/products/'+line_item.handle
      });
    }
  }
  ,reddit_add_to_cart: function (line_item) {
    // try {
    //   if (rdt) {
    //     rdt('track', 'AddToCart', {
    //         "currency": "USD",
    //         "itemCount": 1,
    //         "value": line_item.final_price/100
    //     });
    //   }
    // } catch(err) {
    //   console.log("Reddit module missing", err)
    // }
  }
  ,ctv_add_to_cart: function (line_item) {
    var ctvATCImg = document.createElement('img');
    ctvATCImg.src = 'https://arttrk.com/pixel/?ad_log=referer&action=signup&pixid=39612b0c-a361-4511-8cf8-556578cc9058';
    ctvATCImg.width = 1;
    ctvATCImg.height = 1;
    ctvATCImg.border = 0;
    ctvATCImg.alt = "CTV Add to Cart";
    document.body.appendChild(ctvATCImg);
  }
  ,amazon_add_to_cart: function (line_item) {
    if (amzn) {
      amzn('trackEvent', "Lead_IHM Guardian Bikes Add To Cart");
    }
  }
  ,addMatchingBell: function (bikeSku, discountCode) {
    let bikeSkuSplit= bikeSku.split('-')
    let bikeColor = bikeSkuSplit[bikeSkuSplit.length-1]
    let matchingBells = {
      'GEL': 40734680580189,
      'BNG': 40734680514653,
      'MP': 40734680744029,
      'BB': 40734680449117,
      'PT': 40734680940637,
      'BR': 40734680711261,
      'AP': 40734680940637,
      'PA': 40734681006173,
      'BG': 40734680547421,
      'LB': 40734680809565,
      'BP': 40734680645725
    }
    let matchingBellId = matchingBells[bikeColor]
    guardianAPI.addMultipleItemsToCart([{id: matchingBellId, quantity: 1, properties: {'Code': discountCode, 'Free': 'w/ bike', '_discount': 19.99}}])
  }
  ,afterCartCallback: function (cart, activeUpsellItemId) {
    // var popupOpenedCart = guardianAPI.getCookie('holiday_delivery_popup_cart')
    // if (!popupOpenedCart) {
    //     $('.holiday-delivery-learn-more').click()
    //     guardianAPI.setCookie('holiday_delivery_popup_cart', 1, 30)
    // }
    $('span', $('a.albar_ajaxcart__product-name:contains("Digital Gift Card")').parent()).hide()

    // Add fifty off discount messaging
    var bikeCount = 0;
    var bellCount = 0;
    var helmetCount = 0;
    var lockCount = 0;
    var pumpCount = 0;
    var bikeProduct;
    var bikeProductId;
    var bikeVariantId;
    
    let singleSpeedBikes = cart.items.filter(item => ['14 Inch Bike', '16 Inch Bike', '20 Inch Small Bike'].indexOf(item.product_title) > -1)
    let multiSpeedBikes = cart.items.filter(item => ['20 Inch Large Bike', '24 Inch Bike', '26 Inch Bike'].indexOf(item.product_title) > -1)
    let newTrainingWheels = cart.items.filter(item => item.product_id == 7607132717149)
    let oldTrainingWheels = cart.items.filter(item => item.product_id == 7074665005149)
    let hasSingleSpeedOnly = singleSpeedBikes.length > 0 && multiSpeedBikes.length == 0
    let hasOldTrainingWheelOnly = oldTrainingWheels.length > 0 && newTrainingWheels.length == 0
    if (hasSingleSpeedOnly && hasOldTrainingWheelOnly) {
      console.log("SUGGEST NEW TRAINING WHEEL")
      document.querySelectorAll('.albar_ajaxcart__product-name').forEach(each => {
          if (each.innerText.indexOf("Training Wheels") > -1) {
              let trainingWheelsContainer = each.closest('.albar_grid')
              if (trainingWheelsContainer) {
                  var message = $('<div class="recommended-training-wheel-cart"><p>For the bike(s) in your cart, we recommend our new training wheels</p><a href="/products/training-wheels" class="gb-cta--black--primary">New Training Wheels</a></div>')
                message.insertAfter(trainingWheelsContainer)
              }
          }
      })
    } else {
      console.log("TRAINING WHEEL GOOD")
    }
    
    console.log("singleSpeedBikes", singleSpeedBikes)
    // var activeUpsellItemId
    if (!activeUpsellItemId) {
      var activeUpsellItemIdFromCookies = guardianAPI.getCookie('activeUpsellItemId')
      if (activeUpsellItemIdFromCookies) {
        var checkIfUpsellItemStillExists = cart.items.find(function(item) {
          return item.id == parseInt(activeUpsellItemIdFromCookies)
        })
        if (checkIfUpsellItemStillExists) {
          activeUpsellItemId = parseInt(activeUpsellItemIdFromCookies)
        }
      }
    }
    
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i]
      if (item.product_type == 'Kids Bikes') {
        if (!activeUpsellItemId) {
          activeUpsellItemId = item.id
          bikeProduct = item
          bikeProductId = item.product_id
          bikeVariantId = item.id
        } else if (parseInt(activeUpsellItemId) === item.id) {
          guardianAPI.setCookie('activeUpsellItemId', activeUpsellItemId, 7)
          bikeProduct = item
          bikeProductId = item.product_id
          bikeVariantId = item.id
        }
        bikeCount += item.quantity
      } else if (item.product_type == 'Bells') {
        bellCount += item.quantity
      } else if (item.product_type == 'Helmets') {
        helmetCount += item.quantity
      } else if (item.product_id === 7103920767069) {
        pumpCount += item.quantity
      } else if (item.product_id === 6960518561885) {
        lockCount += item.quantity
      }
    }
    $('.buy-two-save-50').remove()
    // if(document.cookie.indexOf('discount_code') > -1){
    //   return;
    // }
    let discountCode = guardianAPI.getCookie('discount_code')
    if (discountCode) {
      let isKitDiscountCode = (discountCode.indexOf('KIT10-') > -1 || discountCode.indexOf('KIT10_') > -1)
      let isLockPumpDiscountCode = (discountCode.indexOf('LOCKPUMP') > -1 || discountCode.indexOf('FLP_') > -1 || discountCode.indexOf('FLP-') > -1 || discountCode.indexOf('FREELOCKPUMP-') > -1 || discountCode.indexOf('FREELOCKPUMP_') > -1)
      let hasAddedLockAndPump = guardianAPI.getCookie('lock_and_pump')
      // let hasAddedLockAndPump = false
      if (bikeCount == 1 && bellCount == 0 && isKitDiscountCode) {
        let bike = cart.items.find(function(item) {
          return item.product_type == 'Kids Bikes'
        })
        if (bike) {
          guardianAPI.addMatchingBell(bike.sku, discountCode)
        }
      }
      // if (bikeCount == 1 && pumpCount == 0 && lockCount == 0 && isLockPumpDiscountCode && !hasAddedLockAndPump) {
        // let lockAndPump = [{id: 41143545135197, quantity: 1, properties: {_discount: 29.00}},{id: 41230368800861, quantity: 1, properties: {_discount: 19.00}}]
        // let lockAndPump = [{id: 41143545135197, quantity: 1},{id: 41230368800861, quantity: 1}]
        // console.log("lockAndPump", lockAndPump)
        // setTimeout(() => {
        //   guardianAPI.addMultipleItemsToCart(lockAndPump)
        //   guardianAPI.setCookie('lock_and_pump', true)
        // }, 750)
      // }
    }
    
    if (bikeCount == 1 && cart.items.length == 1) {
      var message = $('<div class="buy-two-save-50"> <img class="buy-two-save-50-img" src="https://cdn.shopify.com/s/files/1/1030/6965/files/buy-two-save-50.png?v=1626291402" alt="a discount offering fifty dollars off purchase of two bikes" /> <div class="buy-two-save-50-content"> <p class="buy-two-save-50-content-header">Buy 2 Bikes, Save $50</p> <p class="buy-two-save-50-content-text">Add another bike to your cart and save $50 at checkout.</p> </div> </div>')
//       message.insertBefore('#ajax-cart-instructions')
//       $('#ajax-cart-upsell').append(message)
    } else if (bikeCount > 1) {
//       var message = $('<div class="buy-two-save-50"> <img class="buy-two-save-50-img" src="https://cdn.shopify.com/s/files/1/1030/6965/files/buy-two-save-50.png?v=1626291402" alt="a discount offering fifty dollars off purchase of two bikes" /> <div class="buy-two-save-50-content"> <p class="buy-two-save-50-content-header">Buy 2 Bikes, Save $50</p> <p style="font-size: 16px;" class="buy-two-save-50-content-text">Discount applied at checkout.</p> </div> </div>')
//       message.insertBefore('#ajax-cart-instructions')
//       $('#ajax-cart-upsell').append(message)
    }
    guardianAPI.addFreeText()
    // guardianAPI.handleBonusSeat()
    // guardianAPI.removeBackordered(cart)
    var recommendedProductIds = [];
    var cartAccessories = {};
    if (bikeProductId && helmetCount == 0) {
      cartAccessories.helmet = false
      recommendedProductIds.push(4753662607453)
    } else {
      cartAccessories.helmet = true
    }
    if (bikeProductId && bellCount == 0) {
      cartAccessories.bell = false
      recommendedProductIds.push(4740032069725)
    } else {
      cartAccessories.bell = true
    }
    guardianAPI.showRecommendedProducts(bikeProduct, bikeVariantId, cartAccessories, cart, activeUpsellItemId)
  }
  ,formatPrice: function (cents) {
    if (cents%100 == 0) {
      return "$"+(cents/100)
    } else {
      return (cents/100).toLocaleString("en-US", {style:"currency", currency:"USD"})
    }
  }
  ,formatSrcSet: function (src) {
    return src.replace(".jpg", "_425x.jpg")+" 425w, "+src.replace(".jpg", "_768x.jpg")+" 768w, "+src.replace(".jpg", "_900x.jpg")+" 900w, "
  }
  ,setCookie: function (name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  ,getCookie: function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }
  ,eraseCookie: function (name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  ,getDeliveryEstimate: function(transitDays, zip, shippingFrom) {
    console.log("shippingFrom", shippingFrom)
    // Set current date info
    let d = new Date();
    let currentDay = d.getUTCDay();
    let currentDate = d.getUTCDate();
    let currentDatePadded = currentDate.toString().padStart(2, '0');
    let currentYear = d.getUTCFullYear();
    let currentMonth = d.getUTCMonth()+1
    let currentMonthPadded = currentMonth.toString().padStart(2, '0');

    
    // Set cutoff time and optional buffer dates
    // normal cutoff is 18:00
    let cutoffTimeUTC = '18:00'
    if (shippingFrom == 'California') {
      // normal cutoff is 22:00
      cutoffTimeUTC = '22:00'
    } else if (shippingFrom == 'Indiana') {
      // normal cutoff is 18:00
      cutoffTimeUTC = '18:00'
    } else if (shippingFrom == 'Pennsylvania') {
      // normal cutoff is 18:00
      cutoffTimeUTC = '18:00'
    }
    let bufferDays = 0;
    if (shippingFrom == 'California') {
      bufferDays = 0;
    } else if (shippingFrom == 'Pennsylvania') {
      bufferDays = 0;
    }
    if (transitDays == 3) {
      bufferDays = parseInt(bufferDays) + 1
    }

    let xxx = d.getUTCHours().toString().padStart(2, '0');
    let yyy = d.getUTCMinutes().toString().padStart(2, '0');
    let zzz = d.getUTCSeconds().toString().padStart(2, '0');


    // Create new date for cutoff time and compare to current time
    let compareDate = `${currentYear}-${currentMonthPadded}-${currentDatePadded}T${cutoffTimeUTC}:00.000Z`
    // let compareDateNow = `${currentYear}-${currentMonthPadded}-${currentDatePadded}T${xxx}:${yyy}:${zzz}.000Z`
    let msUntilCompareDate = new Date(compareDate)-new Date()
    let isTomorrow = false

    let utcDiff = new Date().getUTCDate()-new Date().getDate() == 0 ? 0 : 1 ;


    
    // If the cuttoff time has already passed, set new date info to tomorrow's date
    if (utcDiff > 0 || msUntilCompareDate < 0) {
      isTomorrow = true
      msUntilCompareDate = msUntilCompareDate + (24*1000*60*60)
      // d.setUTCDate(currentDate+1);
      currentDay = d.getUTCDay();
      currentDate = d.getUTCDate();
      currentDatePadded = currentDate.toString().padStart(2, '0');
      currentYear = d.getUTCFullYear();
      currentMonth = d.getUTCMonth()+1
      currentMonthPadded = currentMonth.toString().padStart(2, '0');
      // compareDate = `${currentYear}-${currentMonthPadded}-${currentDatePadded}T${cutoffTimeUTC}:00.000Z`
    }
    // console.log('currentMonth', currentMonth)
    


    // if (isTomorrow) {
    //   d.setUTCDate(currentDate+1);
    //   currentDay = d.getUTCDay();
    //   currentDate = d.getUTCDate();
    //   currentDatePadded = currentDate.toString().padStart(2, '0');
    //   currentYear = d.getUTCFullYear();
    //   currentMonth = d.getUTCMonth()+1
    //   currentMonthPadded = currentMonth.toString().padStart(2, '0');
    //   compareDate = `${currentYear}-${currentMonthPadded}-${currentDatePadded}T${cutoffTimeUTC}:00.000Z`
    // }

    // Find time until the next cutoff date
    // msUntilCompareDate = new Date(compareDate)-new Date()
  
  	let hoursTilCutoff = parseInt(msUntilCompareDate/(1000*60*60))
    let minutesTilCutoff = parseInt((msUntilCompareDate-(hoursTilCutoff*1000*60*60))/(1000*60))
    let secondsTilCutoff = parseInt((msUntilCompareDate-(hoursTilCutoff*1000*60*60)-(minutesTilCutoff*1000*60))/(1000))
    
    // How to get total transit days including weekends before counting holidays
    // deliverySchedule[Index of Weekday][Transit Days - 1]
    // Index of Weekday   =    0 index is Sunday, each row below represents a day of the week
    // Transit Days - 1   =    to get properly indexed delivery day subtract 1 from transit days
    // A Wednesday (index 3) start delivery with a 4 day transit time (index 3, or 4-1) would be equal to:  deliverySchedule[3][4-1]  Result: 6, days from start day, including weekends
    // The result is the index of the delivery day, without holidays
    
    
    //  Logic updated 10/12/2024
    // This one is when Sunday delivery IS ACTIVE
    // var deliveryScheduleAddedDays = [
    //   [1, 3, 4, 5, 8, 9, 10, 11, 12] // Sunday
    //  ,[1, 2, 3, 4, 7, 8, 9, 10, 11] // Monday
    //  ,[1, 2, 3, 6, 7, 8, 9, 10, 13] // Tuesday
    //  ,[1, 2, 3, 6, 7, 8, 9, 12, 13] // Wednesday
    //  ,[1, 2, 3, 6, 7, 8, 11, 12, 13] // Thursday
    //  ,[1, 2, 3, 6, 7, 10, 11, 12, 13] // Friday
    //  ,[1, 4, 5, 6, 9, 10, 11, 12, 13] // Saturday
    // ];
    
    // This one is when Sunday delivery IS NOT ACTIVE
    var deliveryScheduleAddedDays = [
      [2, 3, 4, 5, 8, 9, 10, 11, 12] // Sunday
     ,[1, 2, 3, 4, 7, 8, 9, 10, 11] // Monday
     ,[1, 2, 3, 6, 7, 8, 9, 10, 13] // Tuesday
     ,[1, 2, 3, 6, 7, 8, 9, 12, 13] // Wednesday
     ,[1, 2, 3, 6, 7, 8, 11, 12, 13] // Thursday
     ,[1, 2, 3, 6, 7, 10, 11, 12, 13] // Friday
     ,[2, 4, 5, 6, 9, 10, 11, 12, 13] // Saturday
    ];  
    
    
    // TEMPORARY
    // var deliveryScheduleAddedDays = [
    //   [2, 3, 4, 5, 8, 9, 10, 11, 12] // Sunday
    //  ,[1, 2, 3, 4, 7, 8, 9, 10, 11] // Monday
    //  ,[1, 2, 3, 6, 7, 8, 9, 10, 13] // Tuesday
    //  ,[1, 2, 3, 6, 7, 8, 9, 12, 13] // Wednesday
    //  ,[1, 2, 3, 6, 7, 8, 11, 12, 13] // Thursday
    //  ,[1, 2, 3, 6, 7, 10, 11, 12, 13] // Friday
    //  ,[2, 4, 5, 6, 9, 10, 11, 12, 13] // Saturday
    // ];  
    
    // if (shippingFromCalifornia) {
    //   deliveryScheduleAddedDays = [
    //     [2, 3, 4, 5, 8, 9, 10, 11, 12] // Sunday
    //    ,[1, 2, 3, 4, 7, 8, 9, 10, 11] // Monday
    //    ,[1, 2, 3, 6, 7, 8, 9, 10, 13] // Tuesday
    //    ,[1, 2, 3, 6, 7, 8, 9, 12, 13] // Wednesday
    //    ,[1, 2, 3, 6, 7, 8, 11, 12, 13] // Thursday
    //    ,[1, 2, 3, 6, 7, 10, 11, 12, 13] // Friday
    //    ,[3, 4, 5, 6, 9, 10, 11, 12, 13] // Saturday
    //   ]
    // }
    var currentDayModified = isTomorrow && utcDiff == 0 ? currentDay+1 : currentDay
    if (currentDayModified == 7) {
      currentDayModified = 0;
    }

    // console.log("54345 currentDayModified", currentDayModified)
    // console.log("54345 parseInt(transitDays)-1+bufferDays", parseInt(transitDays)-1+bufferDays)
    // console.log("54345 utcDiff", utcDiff)


    let deliveryModifier = deliveryScheduleAddedDays[currentDayModified][parseInt(transitDays)-1]
    console.log("deliveryModifier", deliveryModifier)
    console.log("currentDayModified", currentDayModified)
    console.log("transitDays", transitDays)
    console.log("bufferDays", bufferDays)
    let deliveryDate = new Date();
    if (isTomorrow) {
      // deliveryDate.setUTCDate(deliveryDate.getDate()+1);
      d.setUTCDate(d.getDate()+1+utcDiff+deliveryModifier+bufferDays);
    } else {
      d.setUTCDate(d.getDate()+deliveryModifier+bufferDays)
    }
    let deliveryDateDate = d.getDate()
    let deliveryDateMonth = d.getMonth()

    console.log("deliveryDateMonth", deliveryDateMonth)
    console.log("deliveryDateDate", deliveryDateDate)
    
    if (deliveryDateMonth === 11) {
      $('.gb-guaranteed-holiday-delivery').removeClass('gb-guaranteed-holiday-delivery--hide')
      console.log("deliveryDateDate", deliveryDateDate)
      if (deliveryDateDate < 25) {
        // Arrives before christmas
        // $('.offer-timer-container').show()
        // $('.gb-guaranteed-holiday-delivery').removeClass('gb-guaranteed-holiday-delivery--after')
        // $('.gb-guaranteed-holiday-delivery-text b').text('Delivers Before Christmas')
      } else {
        // Arrives after christmas
        // $('.offer-timer-container').hide()
        // $('.gb-guaranteed-holiday-delivery').addClass('gb-guaranteed-holiday-delivery--after')
        // $('.gb-guaranteed-holiday-delivery-text b').html('Delivers After Christmas')
        // $('.gb-guaranteed-holiday-delivery-text b').html('<span style="color: #db0028;">Warning!</span><br/>Arrives after Christmas')
        let nextDay = new Date(d.getTime())
        nextDay.setDate(nextDay.getDate() + 1)
        deliveryDateDate = nextDay.getDate()
        deliveryDateMonth = nextDay.getMonth()
      }
    } else {
      $('.gb-guaranteed-holiday-delivery').addClass('gb-guaranteed-holiday-delivery--hide')
    }


    // Manual override for last 5 hours of the month (timezone issue)
    if (deliveryDateMonth === 3) {
      deliveryDateMonth = 2
    }
    let deliveryDateMonthName = months[deliveryDateMonth]
    let deliveryDateDay = d.getDay()



    // console.log("54345 deliveryDateMonth 2", deliveryDateMonth)
    // console.log("54345 deliveryDateMonthName", deliveryDateMonthName)

    
    // console.log("54345 isTomorrow", isTomorrow)
    // console.log("54345 deliveryModifier", deliveryModifier)
    // console.log("54345 currentDay", currentDay)
    
    
    var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    
    let ifOrderedIn = hoursTilCutoff == 0 ? minutesTilCutoff+" min "+secondsTilCutoff+" sec" : hoursTilCutoff+" hrs "+minutesTilCutoff+" min "+secondsTilCutoff+" sec"
    let shipsInText = "<div class='delivery-time-text'><p>Get it by <b>"+days[deliveryDateDay]+" "+deliveryDateMonthName+" "+deliveryDateDate+"</b></p></div>";
    if (isTomorrow) {
      shipsInText = "<div class='delivery-time-text'><p>Order today and get it by <b>"+days[deliveryDateDay]+" "+deliveryDateMonthName+" "+deliveryDateDate+"</b></p><p><span class='change-zip-container'>Ship to: <b>"+zip+"</b><button class='change-zip-button'>(change)</button></span></p></div>";
      // shipsInText = "<div class='delivery-time-text'><p>Order today and get it by <b>"+days[deliveryDateDay]+" "+deliveryDateMonthName+" "+deliveryDateDate+"</b></p></div>";
    } else {
      // shipsInText = "<div class='delivery-time-text'><p>Get it by <b>"+days[deliveryDateDay]+" "+deliveryDateMonthName+" "+deliveryDateDate+"</b> if ordered in the next <b>"+ifOrderedIn+"</b></p></div>";
      shipsInText = "<div class='delivery-time-text'><p>Get it by <b>"+days[deliveryDateDay]+" "+deliveryDateMonthName+" "+deliveryDateDate+"</b> if ordered in the next <b>"+ifOrderedIn+"</b></p><p><span class='change-zip-container'>Ship to: <b>"+zip+"</b><button class='change-zip-button'>(change)</button></span></p></div>";
    }
    $('.being-assembled-date-ship-text').text(days[deliveryDateDay]+" "+deliveryDateMonthName+" "+deliveryDateDate)
    $(".delivery-time-real").html(shipsInText)
    $(".delivery-time-estimate").hide()
    $(".delivery-time-real").show()
    var changeZipButton = document.querySelector(".change-zip-button")
    if (changeZipButton) {
      changeZipButton.addEventListener("click", function(e) {
        e.preventDefault();
        changeZipButton.closest('.zip-main').classList.add('zip-main-show')
        document.querySelector('.zip-form-container').classList.add('zip-form-container-show')
        document.querySelector('#zip-input').focus()
      })
    }
  }
  ,checkTransitLocation: function(indianaDelivery, californiaDelivery, pennsylvaniaDelivery, transitTimeFromCookieIndiana, transitTimeFromCookieCalifornia, transitTimeFromCookiePennsylvania) {
    const locations = [
      { name: 'Indiana', available: indianaDelivery, transitTime: transitTimeFromCookieIndiana },
      { name: 'California', available: californiaDelivery, transitTime: transitTimeFromCookieCalifornia },
      { name: 'Pennsylvania', available: pennsylvaniaDelivery, transitTime: transitTimeFromCookiePennsylvania }
    ];
    console.log("123 locations", locations)
  
    // Filter available locations
    const availableLocations = locations.filter(loc => loc.available);
    console.log("123 availableLocations", availableLocations)
  
    // Function to find location with extreme (min or max) transit time
    const findExtremeTransitLocation = (locs, comparator) => 
      locs.reduce((extreme, loc) => 
        comparator(loc.transitTime, extreme.transitTime) ? loc : extreme
      );
  
    if (availableLocations.length > 0) {
      // Find the location with the minimum transit time among available locations
      return findExtremeTransitLocation(availableLocations, (a, b) => a < b);
    } else {
      // If no locations are available, find the location with the maximum transit time among all locations
      return findExtremeTransitLocation(locations, (a, b) => a > b);
    }
  }
  ,getTransitTime: function (zip, californiaDelivery, indianaDelivery, pennsylvaniaDelivery) {
    // return;
    var transitTime
    var shippingFrom
    // var shippingFromCalifornia
    var zipFormContainer = document.querySelector('.zip-form-container');
    var deliveryVersion = "9.0"
    if (!zipFormContainer) {
    	return;
    }
    guardianAPI.clearZipError()
    var cookieDeliveryVersion = guardianAPI.getCookie("delivery_version")
    if (!cookieDeliveryVersion) {
      console.log("No delivery version found")
    } else if (cookieDeliveryVersion < deliveryVersion) {
      console.log("Delivery version needs updating")
      guardianAPI.eraseCookie("delivery_zip")
      guardianAPI.eraseCookie("transit_time")
      guardianAPI.eraseCookie("delivery_version")
    } else {
      console.log("Delivery version current")
    }
    if (zip && !/^\d{5}(?:[-\s]\d{4})?$/.test(zip)) {
        guardianAPI.handleZipError("Invalid Zip")
        return;
    }
    if (zip) {
      guardianAPI.setCookie("delivery_zip", zip, 2)
      transitTime = null
    } else {
      var deliveryZipFromCookie = guardianAPI.getCookie("delivery_zip")
      var transitTimeFromCookie = guardianAPI.getCookie("transit_time")
      var transitTimeFromCookieCalifornia = guardianAPI.getCookie("transit_time_california")
      var transitTimeFromCookieIndiana = guardianAPI.getCookie("transit_time_indiana")
      var transitTimeFromCookiePennsylvania = guardianAPI.getCookie("transit_time_pennsylvania")
      if (deliveryZipFromCookie) {
        zip = deliveryZipFromCookie;
      }
      if (transitTimeFromCookie) {
        var transitLocations = guardianAPI.checkTransitLocation(indianaDelivery, californiaDelivery, pennsylvaniaDelivery, transitTimeFromCookieIndiana, transitTimeFromCookieCalifornia, transitTimeFromCookiePennsylvania)
        console.log("transitLocations 1", transitLocations)
        transitTime = transitLocations.transitTime
        shippingFrom = transitLocations.shippingFrom
      }
    }
    clearInterval(intervalID)
    if (zip && transitTime) {
      guardianAPI.getDeliveryEstimate(transitTime, zip, shippingFrom)
      intervalID = setInterval(function() {
          guardianAPI.getDeliveryEstimate(transitTime, zip, shippingFrom)
      }, 1000)
      var transitTimeSent = guardianAPI.getCookie("ga_transit_time_sent")
      if (window.ga && !transitTimeSent) {
        ga('send', 'event', 'Delivery Info', 'Transit Time', transitTime)
        guardianAPI.setCookie("ga_transit_time_sent", true, 1)
      }
      return;
    }
    $.ajax({
      url : 'https://h1doidxqa9.execute-api.us-east-1.amazonaws.com/api/location',
      type : 'POST',
//       dataType:'json',
      contentType: 'application/json' ,
      data: JSON.stringify({zip: zip}),
      success : function(data) {
        document.querySelector('.zip-main').classList.remove('zip-main-show')
        $(".delivery-time-estimate").hide();
        $(".delivery-time-real").show();
        var dataJSON = JSON.parse(data)
        // var shorterTransitTime = (californiaDelivery && dataJSON.transitTimeCalifornia < dataJSON.transitTimeIndiana) ? dataJSON.transitTimeCalifornia : dataJSON.transitTimeIndiana;
        // var shippingFromCalifornia = (californiaDelivery && dataJSON.transitTimeCalifornia < dataJSON.transitTimeIndiana) ? true : false;

        var transitTimeIndiana = dataJSON.transitTimeIndiana || 4
        var transitTimeCalifornia = dataJSON.transitTimeCalifornia || 4
        var transitTimePennsylvania = dataJSON.transitTimePennsylvania || 4

        if (dataJSON.region_code == 'TX') {
          transitTimeIndiana = 3
          transitTimeCalifornia = 3
          transitTimePennsylvania = 3
        }

        var transitLocations = guardianAPI.checkTransitLocation(indianaDelivery, californiaDelivery, pennsylvaniaDelivery, transitTimeIndiana, transitTimeCalifornia, transitTimePennsylvania)
        console.log("transitLocations 2", transitLocations)
        transitTime = transitLocations.transitTime
        shippingFrom = transitLocations.name

        if (transitTime > 3) {
          transitTime = parseInt(transitTime) + 1
        }

        
        guardianAPI.setCookie("transit_time", transitTime, 2)
        guardianAPI.setCookie("transit_time_california", transitTimeCalifornia, 2)
        guardianAPI.setCookie("transit_time_indiana", transitTimeIndiana, 2)
        guardianAPI.setCookie("transit_time_pennsylvania", transitTimePennsylvania, 2)
        guardianAPI.setCookie("delivery_zip", dataJSON.postal, 2)
        guardianAPI.setCookie("delivery_version", deliveryVersion, 2)
      	guardianAPI.getDeliveryEstimate(transitTime, dataJSON.postal, shippingFrom)
        clearInterval(intervalID)
        intervalID = setInterval(() => {
        	guardianAPI.getDeliveryEstimate(transitTime, dataJSON.postal, shippingFrom)
        }, 1000)
        zipFormContainer.classList.remove('zip-form-container-show')
        document.querySelector('#zip-input').value = ''
        if (window.ga) {        
          ga('send', 'event', 'Delivery Info', 'Transit Time', transitTime)
          guardianAPI.setCookie("ga_transit_time_sent", true, 1)
        }
      },
      error : function(request,error) {      
        console.log('error:', error)
        guardianAPI.handleZipError("Zip Code Error")
      }
    });
  }
  ,checkForAirosUpsell: function(product, variant) {
    var modelOption = variant.option2
    var otherModel = null;
    if (modelOption.toLowerCase() == 'ethos') {
      otherModel = 'airos';
    } else if (modelOption.toLowerCase() == 'airos') {
      otherModel = 'ethos';
    }
    var otherVariant = otherModel && product.variants.find(each => each.option2.toLowerCase() == otherModel && each.option2 == variant.option2)
    var hasFreeSeat = document.querySelector('#freeBonusSeat')
    if (!otherVariant) {
      // document.querySelector(".airos-upsell-container").style.display = 'none';
        document.querySelector(".airos-upsell-container").classList.add("airos-upsell-container--hidden");
      if (!hasFreeSeat) {
        document.querySelector(".optional-addons-header").classList.add("optional-addons-header--hidden");
      }
    } else {
      // document.querySelector(".airos-upsell-container").style.display = 'flex';
        document.querySelector(".airos-upsell-container").classList.remove("airos-upsell-container--hidden");
      if (modelOption.toLowerCase() == 'airos') {
        try {
          document.getElementById("airos_upsell").checked = true;
        } catch(err) {
          console.log("Error setting checkbox")
        }
      }
      if (hasFreeSeat) {
        document.querySelector(".optional-addons-header").classList.remove("optional-addons-header--hidden");
        // document.querySelector(".optional-addons-header").style.display = 'block';
      }
    }
  },
  asyncAddToCart: function(itemToAdd) {
    return new Promise(function (resolve, reject) {
      let properties = itemToAdd.properties ? itemToAdd.properties : {} ;
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: itemToAdd.quantity,
          id: itemToAdd.id,
          properties: properties
        },
        dataType: 'json',
        complete: function(response) {
          resolve(response)
        }
      })
    })
    console.log("itemsToAdd", itemsToAdd)
  },
  asyncRemoveVariantIdFromCart: async function(variantId, loadCart, removeAll) {
    let cart = await guardianAPI.getCart()
    let item = cart.items.find(function(each) {
      console.log(each.variant_id, "==", variantId, each.variant_id == variantId)
      return each.variant_id == variantId
    })
    console.log("item", item)
    if (!item) {
      return;
    }
    console.log("item.quantity", item.quantity)
    let newQuantity = removeAll ? 0 : item.quantity - 1
    console.log("newQuantity", newQuantity)
    return new Promise(function (resolve, reject) {      
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          quantity: newQuantity,
          id: variantId
        },
        dataType: 'json',
        complete: function(response) {
          resolve(response)
          ajaxCart.load(loadCart);
        }
      })
    })
    
  },
  cartUpdateMultipleVariants: async function(itemsToUpdate, loadCart) {
    let updates = {}
    itemsToUpdate.forEach(function(each) {
      updates[each.id] = each.quantity
    })
    return new Promise(function (resolve, reject) {      
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: updates
        },
        dataType: 'json',
        complete: function(response) {
          resolve(response)
          ajaxCart.load(loadCart);
        }
      })
    })
  },
  addMultipleItemsToCart: async function(itemsToAdd, loadCart = true) {
    console.log("itemsToAdd", itemsToAdd)
    // try {
    //   for (let i = 0; i < itemsToAdd.length; i++) {
    //     if (!itemToAdd.properties) {
    //       itemToAdd.properties = {}
    //     }
    //     let response = await guardianAPI.asyncAddToCart(itemsToAdd[i])
    //   }
    //   ajaxCart.load(loadCart);
    //   return true
    // } catch(err) {
    //   return false
    // }
    return new Promise(function (resolve, reject) {
      for (let i = 0; i < itemsToAdd.length; i++) {
        itemToAdd = itemsToAdd[i]
        if (!itemToAdd.properties) {
          itemToAdd.properties = {}
        }
      }
      console.log("itemsToAdd", itemsToAdd)
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          items: itemsToAdd
        },
        dataType: 'json',
        complete: function(response) {
          ajaxCart.load(loadCart);
          resolve(true)
        }
      })
    })
  },
  getQueryParam: function(param) {
    var urlParams = new URLSearchParams(window.location.search);
    var paramValue = urlParams.get(param);
    return paramValue;
  },
  setQueryParam: function(param, value) {
    var searchParams = new URLSearchParams(window.location.search)
    searchParams.set(param, value);
    var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    history.pushState(null, '', newRelativePathQuery);
    var popStateEvent = new PopStateEvent('popstate');
    dispatchEvent(popStateEvent);
  },
  removeQueryParam: function(param) {
    var searchParams = new URLSearchParams(window.location.search)
    searchParams.delete(param);
    var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    history.pushState(null, '', newRelativePathQuery);
    var popStateEvent = new PopStateEvent('popstate');
    dispatchEvent(popStateEvent);
  },
  setBundle: async function (product, variant, firstLoad) {
    if (firstLoad) {
      return;
    }
    var recommendedBundle = document.querySelector('[data-recommended-bundle][data-sku="'+variant.sku+'"]')
    var recommendedHelmets = document.querySelector('[data-recommended-helmets]')
    if (!recommendedBundle) {
      return
    }
    var recommendedBundleData = JSON.parse(recommendedBundle.dataset.recommendedBundle)
    var recommendedHelmetsData = JSON.parse(recommendedHelmets.dataset.recommendedHelmets)
    var recommendedVariantId = parseInt(recommendedBundleData[0].replace('gid://shopify/ProductVariant/', ''))
    var recommendedHelmet = recommendedHelmetsData.find(function(each) {return each.id === recommendedVariantId})

    // Remove current bundle
    // document.querySelectorAll('.bike-bundle-item--accessory').forEach(function(each) {each.remove()})

    // Fetch bike and bunle data
    var productIds = []
    productIds.push(product.id)
    let bikeData
    try {
      let response = await guardianAPI.getProductsInfo(productIds)
      bikeData = response.data.products.edges.find(function(productEdge) {
        return productEdge.node.id.indexOf(product.id) > -1
      })
    } catch(err) {
      console.log("Could not fetch products", err)
    }

    // Set bike bundle data
    document.querySelector('.bike-bundle-item-bike-img img').setAttribute('src', variant.featured_image.src.replace('.jpg', '_250x.jpg').replace('.png', '_250x.png'))
    // document.querySelector('.bike-bundle-item-helmet-img img').setAttribute('src', recommendedHelmet.image)
    var bikeVariant = document.querySelector('.bike-bundle-item--bike')
    bikeVariant.querySelector(".bike-bundle-item-compare-price").innerHTML = "Orig. "+(variant.price/100).toLocaleString("en-US", {style:"currency", currency:"USD"}).replace(".00", "")
    bikeVariant.querySelector('.bike-bundle-item-variant').innerHTML = variant.option1+" / "+variant.option2
    if (variant.available) {
      bikeVariant.querySelector(".bike-bundle-item-stock-status").classList.remove('bike-bundle-item-stock-status--unavailable')
      bikeVariant.querySelector(".bike-bundle-item-stock-status-text").innerHTML = 'In stock, ships within 1-2 days'
    } else {
      bikeVariant.querySelector(".bike-bundle-item-stock-status").classList.add('bike-bundle-item-stock-status--unavailable')
      bikeVariant.querySelector(".bike-bundle-item-stock-status-text").innerHTML = 'Out of Stock'
    }

    // Set bundled items data
    document.querySelectorAll('.bike-bundle-item--accessory').forEach(function(each) {each.remove()})
    var totalPrice = variant.price;
    var recommendedAccessoryContainer = document.querySelector('.bike-bundle-item--accessories')
    recommendedBundleData.forEach(function(each) {
      var recommendedVariantId = parseInt(each.replace('gid://shopify/ProductVariant/', ''))
      var recommendedHelmet = recommendedHelmetsData.find(function(each) {return each.id === recommendedVariantId})
      var recommendedHelmetImg = recommendedHelmet.image
      var recommendedHelmetTitle = recommendedHelmet.product_title
      var recommendedHelmetPrice = (recommendedHelmet.price/100).toLocaleString("en-US", {style:"currency", currency:"USD"}).replace(".00", "")
      var recommendedHelmetAvailableText
      if (recommendedHelmet.available) {
        recommendedHelmetAvailableText = '<p class="bike-bundle-item-stock-status"><span style="font-size: 20px; margin-right: 5px;">&#x25cf;</span><span class="bike-bundle-item-stock-status-text">In stock, ships within 1-2 days</span></p>'
      } else {
        recommendedHelmetAvailableText = '<p class="bike-bundle-item-stock-status bike-bundle-item-stock-status--unavailable"><span style="font-size: 20px; margin-right: 5px;">&#x25cf;</span><span class="bike-bundle-item-stock-status-text">Out of Stock</span></p>'
      }

      var accessoryTemplate = `<div class="bike-bundle-item bike-bundle-item--accessory" data-variant-id="${ recommendedHelmet.id }">
        <div class="bike-bundle-item-img bike-bundle-item-helmet-img">
            <img src="${recommendedHelmetImg}" />
          </div>
          <div class="bike-bundle-item-main">
            <p class="bike-bundle-item-header">${recommendedHelmetTitle}</p>
            <p class="bike-bundle-item-variant">${recommendedHelmet.option1} / ${recommendedHelmet.option2}</p>
            <div class="bike-bundle-item-price">
              <p class="bike-bundle-item-compare-price">Orig. ${recommendedHelmetPrice}</p>
              ${recommendedHelmetAvailableText}
            </div>
            <div class="bike-bundle-item-swatches">
              ${recommendedHelmetsData.filter(function(recommendedHelmetVariant) {
                var currentHelmet = recommendedHelmetsData.find(function(each2) {return each2.id === recommendedHelmetVariant.id})
                return currentHelmet.product_id == recommendedHelmet.product_id && currentHelmet.option1 == recommendedHelmet.option1
              }).map(function(recommendedHelmetVariant) {
                var currentHelmet = recommendedHelmetsData.find(function(each2) {return each2.id === recommendedHelmetVariant.id})
                // return `<div class="bike-bundle-item-swatch ${currentHelmet.id == recommendedHelmet.id ? "bike-bundle-item-swatch--selected" : ""}" data-img="${ recommendedHelmetVariant.image}" data-variant-id="${ recommendedHelmetVariant.id }">
                //   <img src="${ recommendedHelmetVariant.image_thumbnail  }" />
                // </div>`
                return `<div class="bike-bundle-item-swatch-container">
                  <input class="bike-bundle-item-swatch-input" type="radio" id="${ recommendedHelmetVariant.option2 }" name="${recommendedHelmetVariant.product_title}" value="${ recommendedHelmetVariant.option2 }" ${recommendedHelmet.id == currentHelmet.id ? "checked" : ""} data-img="${ recommendedHelmetVariant.image }" data-variant-id="${ recommendedHelmetVariant.id }">
                  <label for="${ recommendedHelmetVariant.option2 }"><img src="${ recommendedHelmetVariant.image_thumbnail }" /></label>
                </div>`
              }).join('\n')}
            </div>
          </div>
        </div>`
      recommendedAccessoryContainer.insertAdjacentHTML('beforeend', accessoryTemplate)
      totalPrice += recommendedHelmet.price
    })
    guardianAPI.addBundleSwatchEvents()
    
    var discountedPrice = totalPrice-parseInt(bikeData.node.bundle_discount.value);
    var totalPriceFormatted = ((totalPrice)/100).toLocaleString("en-US", {style:"currency", currency:"USD"}).replace(".00", "")
    var discountedPriceFormatted = ((discountedPrice)/100).toLocaleString("en-US", {style:"currency", currency:"USD"}).replace(".00", "")
    document.querySelector(".bike-bundle-discounted-price").innerHTML = discountedPriceFormatted
    document.querySelector(".bike-bundle-total-price").innerHTML = totalPriceFormatted



    
    
    // var accessoryVariant = document.querySelector('.bike-bundle-item--accessory')
    // accessoryVariant.dataset.variantId = recommendedHelmet.id
    // accessoryVariant.querySelector(".bike-bundle-item-compare-price").innerHTML = "Orig. "+(recommendedHelmet.price/100).toLocaleString("en-US", {style:"currency", currency:"USD"}).replace(".00", "")
    // console.log("accessoryVariant", accessoryVariant)
    // if (recommendedHelmet.available) {
    //   accessoryVariant.querySelector(".bike-bundle-item-stock-status").classList.remove('bike-bundle-item-stock-status--unavailable')
    //   accessoryVariant.querySelector(".bike-bundle-item-stock-status-text").innerHTML = 'In stock, ships within 1-2 days'
    // } else {
    //   accessoryVariant.querySelector(".bike-bundle-item-stock-status").classList.add('bike-bundle-item-stock-status--unavailable')
    //   accessoryVariant.querySelector(".bike-bundle-item-stock-status-text").innerHTML = 'Out of Stock'
    // }

    // var totalPrice = ((variant.price+recommendedHelmet.price)/100).toLocaleString("en-US", {style:"currency", currency:"USD"}).replace(".00", "")
    // var discountedPrice = ((variant.price+recommendedHelmet.price-5000)/100).toLocaleString("en-US", {style:"currency", currency:"USD"}).replace(".00", "")
    // document.querySelector(".bike-bundle-discounted-price").innerHTML = discountedPrice
    // document.querySelector(".bike-bundle-total-price").innerHTML = totalPrice

  },
  addBundleSwatchEvents: function() {
    document.querySelectorAll('.bike-bundle-item-swatch-input').forEach(function(each) {
      each.addEventListener("change", function(event) {
        console.log("----------->")
        var bundleItem = event.currentTarget.closest('.bike-bundle-item')
        var variantId = event.target.dataset.variantId
        var variantImg = event.target.dataset.img
        bundleItem.querySelector('.bike-bundle-item-helmet-img img').setAttribute('src', variantImg)
        bundleItem.dataset.variantId = variantId
      })
    })
  },
  getProductsInfo: async function(productIds) {
    console.log("starting getProductsInfo", productIds)
        var queryIds = productIds.map(function(each) {
          console.log("typeof each", typeof each)
          if (typeof each == 'number') {
            return "id:"+each.toString()
          } else {
            var strippedId = each.replace("gid://shopify/Product/", "")
            return "id:"+strippedId
          }
        }).join(' OR ');
        var query = `query getProducts {
          products(first: 10, query: "${queryIds}") {
              edges {
                node {
                  id
                  title
                  handle
                  tags
                  bundle_discount: metafield(namespace: "global", key: "bundle_discount") {
                    value
                  }
                  variants(first: 20) {
                    edges {
                      node {
                        id
                        sku
                        title
                        price
          			  quantityAvailable
                        image {
                          id
                          url(transform: {maxWidth: 375})
                        }
                        compareAtPrice
                        selectedOptions {
                          name
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          }`
    
    try {
       const rawResponse = await fetch('https://guardian-bikes.myshopify.com/api/2022-04/graphql.json', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '20ac6b449e03222e95bb58e6b83e3abf'
        },
        body: JSON.stringify({query: query})
      });
      const content = await rawResponse.json();
      return content
    } catch(err) {
      console.log("fetch products error", err)
    }
  },
  setOptions: function(product, variant, isBike, optionName) {
    if (!isBike || product.options.length < 2 || optionName !== 'Color') {
      return;
    }
    let otherVariantsInColor = product.variants.filter(function(each) {
      return each.option1 == variant.option1
    })
    let otherAvailableVariant = product.variants.find(function(each) {
      return each.option1 == variant.option1 && each.option2 != variant.option2
    })
    var preorderInfoCurrent = document.querySelector('.gb-product-info-variant[data-sku="'+variant.sku+'"]'); 
    var preorderDateCurrent = preorderInfoCurrent && preorderInfoCurrent.dataset.preorderDate
    if (!otherAvailableVariant) {
      return;
    }
    // var preorderMax = preorderInfoCurrent && preorderInfoCurrent.dataset.preorderMax
    var preorderInfoOther = document.querySelector('.gb-product-info-variant[data-sku="'+otherAvailableVariant.sku+'"]'); 
    var preorderDateOther = preorderInfoOther && preorderInfoOther.dataset.preorderDate

    // If current variant is not available, and the other variant is either available or has a preorder date, change to it
    if (!variant.available && (otherAvailableVariant.available || preorderDateOther)) {
      document.querySelector('[name="option-1"][value="'+otherAvailableVariant.option2+'"]').click()
      return otherAvailableVariant
    } else if (preorderDateCurrent && otherAvailableVariant.available && !preorderDateOther) {
      // If current variant has a preorder date, and the other one is available without a preorder date, change to it
      document.querySelector('[name="option-1"][value="'+otherAvailableVariant.option2+'"]').click()
      return otherAvailableVariant
    }
  },
  getInventoryForProducts: function(productIds) {
    return new Promise((resolve, reject) => {
      var queryIds = variantIds.map(function(each) {
        console.log("typeof each", typeof each)
        if (typeof each == 'number') {
          return "id:"+each.toString()
        } else {
          var strippedId = each.replace("gid://shopify/ProductVariant/", "")
          return "id:"+strippedId
        }
      }).join(' OR ');
      var query = `query getInventory {
                    productVariants(first: 20, query: "id:${queryIds}") {
                      edges {
                        node {
                          inventoryQuantity
                          sku
                        }
                      }
                    }
                  }`
      $.ajax({
        url : 'https://guardian-bikes.myshopify.com/api/2022-04/graphql.json',
        type : 'POST',
        crossDomain : true,
        dataType: 'json',
        contentType: "application/json",
        data: JSON.stringify({query: query}),
        //       data: JSON.stringify({"query":"{shop{name}}"}),
        headers: {
          'X-Shopify-Storefront-Access-Token': '20ac6b449e03222e95bb58e6b83e3abf',
        },
        success : function(data) {
          console.log("Inventory Data", data)
          resolve(data)
        }
      })
    })
  },
  removeCartItem: function(item, cartMessage) {
    $.ajax({
      url : '/cart/change.js',
      type : 'POST',
      dataType: 'json',
      data: {
        'id': item.id,
        'quantity': 0
      },
      success : function(cart) {
        ajaxCart.load();
        setTimeout(function () {
          if (cartMessage) {
            $('#AlbarCartContainer').append($('<p style="color: #d43b3b; padding: 10px 15px;">'+cartMessage+'</p>'))
          }
        }, 1000)
      },
      error : function(request,error) {
        console.log(error);
      }
    })
  },
  updateViewableAccessories: function () {
    let recommendedAccessories = document.querySelectorAll('.gb-recommended-accessories')
    let recommendedAccessoriesContainer = document.querySelector('.gb-recommended-accessories-container')
    let showAll = recommendedAccessoriesContainer.classList.contains('gb-recommended-accessories-container--view-all')
    recommendedAccessories.forEach(item => {
      var visibleCount = 0;
      item.querySelectorAll('.gb-recommended-accessory').forEach(item2 => {
        if (visibleCount >= 5) {
          if (showAll) {
            item2.style.display = 'flex';
          } else {
            item2.style.display = 'none';
          }
        } else if (!item2.classList.contains('gb-recommended-accessory--hide')) {
            visibleCount++;
            item2.style.display = 'flex';
        }
      })
    });
  },
  gorgiasCaptureCart: async function() {
    const response = await fetch('/cart.json', {
        method: 'GET',
    })
    let cart =  await response.json();
    if (GorgiasChat) {
        GorgiasChat.captureShopifyCart(cart);
    }
  },
  klaviyoAddToCart: async function(item) {
    console.log("klaviyoAddToCart", item)
    _learnq.push(['track', 'Added to Cart', item]);
  },
  getLockAndPumpsToAdd: async function(accessoryOfferAdded) {
    return new Promise ((resolve, reject) => {
      if (accessoryOfferAdded === undefined) {
        accessoryOfferAdded = true
      }
      const discountCode = guardianAPI.getCookie('discount_code')
      const hasAddedLockAndPump = guardianAPI.getCookie('lock_and_pump')
      const isLockPumpDiscountCode = discountCode && (discountCode.indexOf('LOCKPUMP') > -1 || discountCode.indexOf('FLP_') > -1 || discountCode.indexOf('FLP-') > -1 || discountCode.indexOf('FREELOCKPUMP-') > -1 || discountCode.indexOf('FREELOCKPUMP_') > -1)
      if ((!isLockPumpDiscountCode || hasAddedLockAndPump) && accessoryOfferAdded) {
        return resolve([])
      }
      fetch('/cart?view=alternate.json')
        .then(response => response.json())
        .then(data => {
          if (data.error === true) {
            console.log(data.error);
          } else {
            const bikesInCart = data.items.filter(item => item.product_type === "Kids Bikes");
            const locksInCart = data.items.filter(item => item.product_id === 6960518561885);
            const pumpsInCart = data.items.filter(item => item.product_id === 7103920767069);
            const itemsToAdd = []
            if (bikesInCart.length > 0) {
              if (locksInCart.length < 1) {
                itemsToAdd.push({id: 41143545135197, quantity: 1})
              }
              if (pumpsInCart.length < 1) {
                itemsToAdd.push({id: 41230368800861, quantity: 1})
              }
              resolve(itemsToAdd)
            }
          }
        })
        .catch(error => {
          reject(error)
        });
    })
  }
};
